// import React, { useState, useEffect } from 'react';
// import Navbar from '../../../Components/Navbar';
// import Slider from "react-slick";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
// import './plumberStyle.css';
// import PlumberOrderForm from './PlumberOrderForm';
// import PromptLoginCard from '../PromptLoginCard';
// import axios from 'axios';
// import { jwtDecode } from 'jwt-decode';
// import { URL } from '../../../config';

// import image1 from '../images/plumber1.png';
// import image2 from '../images/plumber2.jfif';
// import image3 from '../images/plumber3.jfif';
// import image4 from '../images/plumber4.jpg';

// const Plumber = () => {
//   const [toiletInstall, setToiletInstall] = useState(0);
//   const [faucetInstall, setFaucetInstall] = useState(0);
//   const [sinkInstall, setSinkInstall] = useState(0);
//   const [dishwasherInstall, setDishwasherInstall] = useState(0);
//   const [leakRepair, setLeakRepair] = useState(0);
//   const [faucetRepair, setFaucetRepair] = useState(0);
//   const [toiletRepair, setToiletRepair] = useState(0);
//   const [showerRepair, setShowerRepair] = useState(0);
//   const [drainCleaning, setDrainCleaning] = useState(0);
//   const [showOrderForm, setShowOrderForm] = useState(false);
//   const [showLoginPrompt, setShowLoginPrompt] = useState(false);
//   const [user, setUser] = useState(null);
//   const [formData, setFormData] = useState({});

//   useEffect(() => {
//     const fetchUserData = async () => {
//       try {
//         const token = localStorage.getItem('token');
//         if (token) {
//           const decodedToken = jwtDecode(token);
//           const userId = decodedToken.Id;
//           const extractedUserId = userId.startsWith('user-') ? userId.split('user-')[1] : userId;
//           const response = await axios.get(`${URL}/user/${extractedUserId}`, {
//             headers: {
//               Authorization: `Bearer ${token}`
//             }
//           });
//           setUser(response.data);
//         }
//       } catch (error) {
//         console.error('Error fetching user data:', error);
//       }
//     };
//     fetchUserData();
//     window.scrollTo(0, 0);
//   }, []);

//   const sliderImages = [image1, image2, image3, image4];

//   const settings = {
//     dots: true,
//     infinite: true,
//     speed: 500,
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     autoplay: true,
//     autoplaySpeed: 3000,
//   };

//   const generateTimeSlots = () => {
//     const startTime = 7;
//     const endTime = 21;
//     const timeSlots = [];

//     for (let hour = startTime; hour <= endTime; hour++) {
//       for (let minute = 0; minute < 60; minute += 30) {
//         const time = `${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}`;
//         const displayTime = hour === 12
//           ? `12:${String(minute).padStart(2, '0')} PM`
//           : hour > 12
//             ? `${hour - 12}:${String(minute).padStart(2, '0')} PM`
//             : `${hour}:${String(minute).padStart(2, '0')} AM`;
//         timeSlots.push(<option key={time} value={displayTime}>{displayTime}</option>);
//       }
//     }
//     return timeSlots;
//   };

//   const calculatePrice = () => {
//     let price = 300; // Minimum charge
//     price += toiletInstall * 250;
//     price += faucetInstall * 100;
//     price += sinkInstall * 200;
//     price += dishwasherInstall * 200;
//     price += leakRepair * 1010;
//     price += faucetRepair * 100;
//     price += toiletRepair * 100;
//     price += showerRepair * 100;
//     price += drainCleaning * 150;
//     return price;
//   };

//   const handleGetService = (e) => {
//     e.preventDefault();
//     const formDetails = {
//       toiletInstall,
//       faucetInstall,
//       sinkInstall,
//       dishwasherInstall,
//       leakRepair,
//       faucetRepair,
//       toiletRepair,
//       showerRepair,
//       drainCleaning,
//       price: calculatePrice(),
//       date: e.target.date.value,
//       time: e.target.time.value
//     };
//     setFormData(formDetails);

//     if (user) {
//       setShowOrderForm(true);
//     } else {
//       setShowLoginPrompt(true);
//     }
//   };

//   const handleOrderSubmit = (orderData) => {
//     console.log("Order Data:", orderData);
//     setShowOrderForm(false);
//   };

//   return (
//     <div>
//       <Navbar />
//       <div className={`plumber-content ${showOrderForm ? 'blur' : ''}`}>
//         <div className="slider-container">
//           <Slider {...settings}>
//             {sliderImages.map((image, index) => (
//               <div key={index}>
//                 <img src={image} alt={`Slide ${index + 1}`} />
//               </div>
//             ))}
//           </Slider>
//         </div>

//         <div className="plumber-form-container">
//           <div className="plumber-form-header">
//             <h2>Plumber Service</h2>
//             <div className="reviews">
//               <span className="stars">★★★★★</span>
//               <span className="review-count">45,000 Reviews</span>
//             </div>
//             <hr />
//           </div>

//           <form className="plumber-form" onSubmit={handleGetService}>
//             <div className="form-row">
//               <div className="plumber-form-group">
//                 <label>Toilet Installation</label>
//                 <select onChange={(e) => setToiletInstall(parseInt(e.target.value))}>
//                   <option value="0">0</option>
//                   <option value="1">1</option>
//                   <option value="2">2</option>
//                 </select>
//               </div>
//               <div className="plumber-form-group">
//                 <label>Faucet Installation</label>
//                 <select onChange={(e) => setFaucetInstall(parseInt(e.target.value))}>
//                   <option value="0">0</option>
//                   <option value="1">1</option>
//                   <option value="2">2</option>
//                 </select>
//               </div>
//               <div className="plumber-form-group">
//                 <label>Sink Installation</label>
//                 <select onChange={(e) => setSinkInstall(parseInt(e.target.value))}>
//                   <option value="0">0</option>
//                   <option value="1">1</option>
//                   <option value="2">2</option>
//                 </select>
//               </div>
//               <div className="plumber-form-group">
//                 <label>Dishwasher Installation</label>
//                 <select onChange={(e) => setDishwasherInstall(parseInt(e.target.value))}>
//                   <option value="0">0</option>
//                   <option value="1">1</option>
//                   <option value="2">2</option>
//                 </select>
//               </div>
//             </div>
//             <div className="form-row">
//               <div className="plumber-form-group">
//                 <label>Leak Repair</label>
//                 <select onChange={(e) => setLeakRepair(parseInt(e.target.value))}>
//                   <option value="0">0</option>
//                   <option value="1">1</option>
//                   <option value="2">2</option>
//                 </select>
//               </div>
//               <div className="plumber-form-group">
//                 <label>Faucet Repair</label>
//                 <select onChange={(e) => setFaucetRepair(parseInt(e.target.value))}>
//                   <option value="0">0</option>
//                   <option value="1">1</option>
//                   <option value="2">2</option>
//                 </select>
//               </div>
//             {/* </div>
//             <div className="form-row"> */}
//               <div className="plumber-form-group">
//                 <label>Toilet Repair</label>
//                 <select onChange={(e) => setToiletRepair(parseInt(e.target.value))}>
//                   <option value="0">0</option>
//                   <option value="1">1</option>
//                   <option value="2">2</option>
//                 </select>
//               </div>
//               <div className="plumber-form-group">
//                 <label>Shower Repair</label>
//                 <select onChange={(e) => setShowerRepair(parseInt(e.target.value))}>
//                   <option value="0">0</option>
//                   <option value="1">1</option>
//                   <option value="2">2</option>
//                 </select>
//               </div>
//             </div>
//             <div className="form-row">
//               <div className="plumber-form-group">
//                 <label>Drain Cleaning</label>
//                 <select onChange={(e) => setDrainCleaning(parseInt(e.target.value))}>
//                   <option value="0">0</option>
//                   <option value="1">1</option>
//                   <option value="2">2</option>
//                 </select>
//               </div>
//               <div className="plumber-form-group">
//                 <label>Price</label>
//                 <input type="text" placeholder="Price" readOnly value={`${calculatePrice()} tk`} />
//               </div>
//             </div>
//             <div className="form-row">
//               <div className="plumber-form-group">
//                 <label>Date</label>
//                 <input type="date" name="date" required />
//               </div>
//               <div className="plumber-form-group">
//                 <label>Time</label>
//                 <select name="time" required>
//                   {generateTimeSlots()}
//                 </select>
//               </div>
//             </div>
//             <button type="submit">Get Service</button>
//           </form>
//         </div>
//       </div>

//       {showOrderForm && (
//         <PlumberOrderForm
//           onClose={() => setShowOrderForm(false)}
//           onSubmit={handleOrderSubmit}
//           formData={formData}
//           user={user}
//         />
//       )}

//       {showLoginPrompt && (
//         <PromptLoginCard onClose={() => setShowLoginPrompt(false)} />
//       )}
//     </div>
//   );
// };

// export default Plumber;

// ************** All is okay plumber ***************** //

// import React, { useState, useEffect, useMemo } from 'react';
// import { useLocation } from 'react-router-dom';
// import Navbar from '../../../Components/Navbar';
// import axios from 'axios';
// import { jwtDecode } from 'jwt-decode';
// import { URL } from '../../../config';
// import DatePicker from 'react-datepicker';
// import 'react-datepicker/dist/react-datepicker.css';
// import { FaCalendarAlt } from 'react-icons/fa';

// import PlumberOrderForm from './PlumberOrderForm';
// import PromptLoginCard from '../PromptLoginCard';

// // Replace this with your actual plumber hero image file
// import heroImage from '../images/plumber1.png';

// import './plumberStyle.css';

// const Plumber = () => {
//   const location    = useLocation();
//   const rebookState = location.state?.fromRebook || false;     // detect rebook flag
//   const prevOrder   = useMemo(
//     () => location.state?.previousOrder || {},
//     [location.state?.previousOrder]
//   );

//   // Service options for Plumber
//   const [toiletInstall, setToiletInstall] = useState(0);
//   const [faucetInstall, setFaucetInstall] = useState(0);
//   const [sinkInstall, setSinkInstall] = useState(0);
//   const [dishwasherInstall, setDishwasherInstall] = useState(0);
//   const [leakRepair, setLeakRepair] = useState(0);
//   const [faucetRepair, setFaucetRepair] = useState(0);
//   const [toiletRepair, setToiletRepair] = useState(0);
//   const [showerRepair, setShowerRepair] = useState(0);
//   const [drainCleaning, setDrainCleaning] = useState(0);
//   const [pipeCleaning, setPipeCleaning] = useState(0);
//   const [tankCleaning, setTankCleaning] = useState(0);
//   const [issueCheckup, setIssueCheckup] = useState(false);

//   const [showOrderForm, setShowOrderForm] = useState(false);
//   const [showLoginPrompt, setShowLoginPrompt] = useState(false);
//   const [user, setUser] = useState(null);
//   const [formData, setFormData] = useState({});

//   // const [selectedDate, setSelectedDate] = useState(new Date());

//   const getInitialDate = () => {
//       const now = new Date();
//       const currentHour = now.getHours();
//       // If current time is before 7:00 AM or after 9:00 PM, set date to tomorrow
//       if (currentHour < 7 || currentHour >= 21) {
//         const tomorrow = new Date();
//         tomorrow.setDate(now.getDate() + 1);
//         return tomorrow;
//       }
//       return now;
//     };

//   const [selectedDate, setSelectedDate] = useState(getInitialDate());

//   useEffect(() => {
//     if (rebookState) {
//       setToiletInstall(prevOrder.Toilet_in       || 0);
//       setFaucetInstall(prevOrder.Faucet_in       || 0);
//       setSinkInstall(prevOrder.Sink_in           || 0);
//       setDishwasherInstall(prevOrder.Dishwasher_in || 0);
//       setLeakRepair(prevOrder.Leak_repair        || 0);
//       setFaucetRepair(prevOrder.Faucet_repair    || 0);
//       setToiletRepair(prevOrder.Toilet_repair    || 0);
//       setShowerRepair(prevOrder.Shower_repair    || 0);
//       setDrainCleaning(prevOrder.Drain_cleaning  || 0);
//       setPipeCleaning(prevOrder.pipe_cleaning    || 0);
//       setTankCleaning(prevOrder.tank_cleaning    || 0);
//       setIssueCheckup(prevOrder.issue_checkup    || false);
//     }
//   }, [rebookState, prevOrder]);

//   // Fetch user data if token exists
//   useEffect(() => {
//     const fetchUserData = async () => {
//       try {
//         const token = localStorage.getItem('token');
//         if (token) {
//           const decodedToken = jwtDecode(token);
//           const userId = decodedToken.Id;
//           const extractedUserId = userId.startsWith('user-')
//             ? userId.split('user-')[1]
//             : userId;
//           const response = await axios.get(`${URL}/user/${extractedUserId}`, {
//             headers: { Authorization: `Bearer ${token}` }
//           });
//           setUser(response.data);
//         }
//       } catch (error) {
//         console.error('Error fetching user data:', error);
//       }
//     };
//     fetchUserData();
//     window.scrollTo(0, 0);
//   }, []);

//   // Generate time slots from 7:00 AM to 9:30 PM similar to Electrician service
//   // const generateTimeSlots = (dateObj) => {
//   //   const startTime = 7;
//   //   const endTime = 21;
//   //   const slots = [];
//   //   const now = new Date();

//   //   const todayStr = now.toISOString().split('T')[0];
//   //   let selectedDateStr = '';
//   //   if (dateObj) {
//   //     selectedDateStr = dateObj.toISOString().split('T')[0];
//   //   }

//   //   let startHour = startTime;
//   //   let startMinute = 0;
//   //   if (selectedDateStr === todayStr) {
//   //     const currentHour = now.getHours();
//   //     const currentMinute = now.getMinutes();
//   //     if (currentHour >= startTime && currentHour < endTime) {
//   //       if (currentMinute > 0 && currentMinute <= 30) {
//   //         startHour = currentHour;
//   //         startMinute = 30;
//   //       } else if (currentMinute > 30) {
//   //         startHour = currentHour + 1;
//   //         startMinute = 0;
//   //       } else {
//   //         startHour = currentHour;
//   //         startMinute = 0;
//   //       }
//   //     } else if (currentHour >= endTime) {
//   //       return [];
//   //     }
//   //   }

//   //   for (let hour = startHour; hour <= endTime; hour++) {
//   //     const minuteStart = hour === startHour ? startMinute : 0;
//   //     for (let minute = minuteStart; minute < 60; minute += 30) {
//   //       if (selectedDateStr === todayStr) {
//   //         const slotTime = new Date();
//   //         slotTime.setHours(hour, minute, 0, 0);
//   //         if (slotTime <= now) continue;
//   //       }
//   //       const displayHour = hour > 12 ? hour - 12 : hour;
//   //       const ampm = hour >= 12 ? 'PM' : 'AM';
//   //       const formattedTime = `${displayHour}:${String(minute).padStart(2, '0')} ${ampm}`;
//   //       slots.push(formattedTime);
//   //     }
//   //   }
//   //   return slots;
//   // };

//   const generateTimeSlots = (dateObj) => {
//     const startTime = 7;
//     const endTime = 21;
//     const slots = [];
//     const now = new Date();
//     const todayStr = now.toISOString().split('T')[0];
//     const selectedDateStr = dateObj ? dateObj.toISOString().split('T')[0] : '';

//     let startHour = startTime;
//     let startMinute = 0;

//     // If the selected date is today, adjust slots based on current time
//     if (selectedDateStr === todayStr) {
//       const currentHour = now.getHours();
//       const currentMinute = now.getMinutes();
//       if (currentHour >= endTime) {
//         return []; // No slots available for today
//       }
//       if (currentHour >= startTime) {
//         // Round up to the next half-hour
//         if (currentMinute > 0 && currentMinute <= 30) {
//           startHour = currentHour;
//           startMinute = 30;
//         } else if (currentMinute > 30) {
//           startHour = currentHour + 1;
//           startMinute = 0;
//         } else {
//           startHour = currentHour;
//           startMinute = 0;
//         }
//       }
//     }

//     for (let hour = startHour; hour <= endTime; hour++) {
//       const minuteStart = hour === startHour ? startMinute : 0;
//       for (let minute = minuteStart; minute < 60; minute += 30) {
//         // Skip past slots for today
//         if (selectedDateStr === todayStr) {
//           const slotTime = new Date(now);
//           slotTime.setHours(hour, minute, 0, 0);
//           if (slotTime <= now) continue;
//         }
//         const displayHour = hour > 12 ? hour - 12 : hour;
//         const ampm = hour >= 12 ? 'PM' : 'AM';
//         const formattedTime = `${displayHour}:${String(minute).padStart(2, '0')} ${ampm}`;
//         slots.push(formattedTime);
//       }
//     }
//     return slots;
//   };

//   // Calculate price based on plumber service selections
//   const calculatePrice = () => {
//     let price = 300; // Base price
//     price += toiletInstall * 250;
//     price += faucetInstall * 100;
//     price += sinkInstall * 200;
//     price += dishwasherInstall * 200;
//     price += leakRepair * 500;
//     price += faucetRepair * 100;
//     price += toiletRepair * 100;
//     price += showerRepair * 100;
//     price += drainCleaning * 150;
//     price += pipeCleaning * 300;
//     price += tankCleaning * 800;
//     price += issueCheckup ? 250 : 0;
//     return price;
//   };

//   // Handle form submission
//   const handleGetService = (e) => {
//     e.preventDefault();
//     let dateStr = '';
//     if (selectedDate) {
//       dateStr = selectedDate.toISOString().split('T')[0];
//     }
//     const time = e.target.time.value;

//     const formDetails = {
//       toiletInstall,
//       faucetInstall,
//       sinkInstall,
//       dishwasherInstall,
//       leakRepair,
//       faucetRepair,
//       toiletRepair,
//       showerRepair,
//       drainCleaning,
//       pipeCleaning,
//       tankCleaning,
//       issueCheckup,
//       price: calculatePrice(),
//       date: dateStr,
//       time
//     };
//     setFormData(formDetails);

//     // Show order form if user is logged in; otherwise prompt login
//     if (user) {
//       setShowOrderForm(true);
//     } else {
//       setShowLoginPrompt(true);
//     }
//   };

//   const handleOrderSubmit = (orderData) => {
//     console.log('Order Data:', orderData);
//     setShowOrderForm(false);
//   };

//   return (
//     <div className="PlumberService-container">
//       <Navbar />

//       {/* Service Card */}
//       <div className="PlumberService-card">
//         {/* Hero Section */}
//         <div className="PlumberService-hero">
//           <img src={heroImage} alt="Plumber Services Hero" />
//         </div>

//         <div className="PlumberService-header">
//           {/* <h1>Professional Plumber Services</h1> */}
//           <h1>
//             {rebookState
//               ? 'Rebook Plumber Service'
//               : 'Professional Plumber Services'}
//           </h1>
//           <div className="PlumberService-rating">★★★★★</div>
//           <div className="PlumberService-reviews">45,000 Verified Reviews</div>
//         </div>

//         {/* Categories / Info Blocks */}
//         <div className="PlumberService-categories">
//           <div className="PlumberService-category">
//             <h5>
//               <span className="PlumberService-categoryIcon">🚽</span> Toilet
//               Installation &amp; Repair
//             </h5>
//             <p className="PlumberService-serviceDescription">
//               Expert installation and repair for toilets ensuring efficient
//               performance and durability.
//             </p>
//           </div>
//           <div className="PlumberService-category">
//             <h5>
//               <span className="PlumberService-categoryIcon">🚰</span> Faucet,
//               Sink &amp; Dishwasher Services
//             </h5>
//             <p className="PlumberService-serviceDescription">
//               Professional installation of faucets, sinks, and dishwashers to
//               optimize your water flow.
//             </p>
//           </div>
//           <div className="PlumberService-category">
//             <h5>
//               <span className="PlumberService-categoryIcon">💧</span> Leak,
//               Shower &amp; Drain Solutions
//             </h5>
//             <p className="PlumberService-serviceDescription">
//               Timely leak detection, shower repair, and drain cleaning to
//               prevent water damage.
//             </p>
//           </div>
//         </div>

//         {/* The Service Form */}
//         <form onSubmit={handleGetService} className="PlumberService-form">
//           <div className="PlumberService-serviceOptions">
//             <div className="PlumberService-optionGroup">
//               <label htmlFor="toiletInstall">Toilet Installation</label>
//               <select
//                 id="toiletInstall"
//                 value={toiletInstall}
//                 onChange={(e) => setToiletInstall(parseInt(e.target.value))}
//               >
//                 <option value="0" defaultValue>
//                   0
//                 </option>
//                 <option value="1">1 Unit</option>
//                 <option value="2">2 Units</option>
//               </select>
//             </div>
//             <div className="PlumberService-optionGroup">
//               <label htmlFor="faucetInstall">Faucet Installation</label>
//               <select
//                 id="faucetInstall"
//                 value={faucetInstall}
//                 onChange={(e) => setFaucetInstall(parseInt(e.target.value))}
//               >
//                 <option value="0" defaultValue>
//                   0
//                 </option>
//                 <option value="1">1 Unit</option>
//                 <option value="2">2 Units</option>
//               </select>
//             </div>
//             <div className="PlumberService-optionGroup">
//               <label htmlFor="sinkInstall">Sink Installation</label>
//               <select
//                 id="sinkInstall"
//                 value={sinkInstall}
//                 onChange={(e) => setSinkInstall(parseInt(e.target.value))}
//               >
//                 <option value="0" defaultValue>
//                   0
//                 </option>
//                 <option value="1">1 Unit</option>
//                 <option value="2">2 Units</option>
//               </select>
//             </div>
//             <div className="PlumberService-optionGroup">
//               <label htmlFor="dishwasherInstall">Dishwasher Installation</label>
//               <select
//                 id="dishwasherInstall"
//                 value={dishwasherInstall}
//                 onChange={(e) => setDishwasherInstall(parseInt(e.target.value))}
//               >
//                 <option value="0" defaultValue>
//                   0
//                 </option>
//                 <option value="1">1 Unit</option>
//                 <option value="2">2 Units</option>
//               </select>
//             </div>
//           </div>

//           <div className="PlumberService-serviceOptions">
//             <div className="PlumberService-optionGroup">
//               <label htmlFor="leakRepair">Leak Repair</label>
//               <select
//                 id="leakRepair"
//                 value={leakRepair}
//                 onChange={(e) => setLeakRepair(parseInt(e.target.value))}
//               >
//                 <option value="0" defaultValue>
//                   0
//                 </option>
//                 <option value="1">1 Spot</option>
//                 <option value="2">2 Spots</option>
//               </select>
//             </div>
//             <div className="PlumberService-optionGroup">
//               <label htmlFor="faucetRepair">Faucet Repair</label>
//               <select
//                 id="faucetRepair"
//                 value={faucetRepair}
//                 onChange={(e) => setFaucetRepair(parseInt(e.target.value))}
//               >
//                 <option value="0" defaultValue>
//                   0
//                 </option>
//                 <option value="1">1 Unit</option>
//                 <option value="2">2 Units</option>
//               </select>
//             </div>
//             <div className="PlumberService-optionGroup">
//               <label htmlFor="toiletRepair">Toilet Repair</label>
//               <select
//                 id="toiletRepair"
//                 value={toiletRepair}
//                 onChange={(e) => setToiletRepair(parseInt(e.target.value))}
//               >
//                 <option value="0" defaultValue>
//                   0
//                 </option>
//                 <option value="1">1 Unit</option>
//                 <option value="2">2 Units</option>
//               </select>
//             </div>
//             {/* <div className="PlumberService-optionGroup">
//               <label htmlFor="showerRepair">Shower Repair</label>
//               <select
//                 id="showerRepair"
//                 onChange={(e) => setShowerRepair(parseInt(e.target.value))}
//               >
//                 <option value="0" defaultValue>
//                   0
//                 </option>
//                 <option value="1">1 Unit</option>
//                 <option value="2">2 Units</option>
//               </select>
//             </div> */}
//           </div>

//           <div className="PlumberService-serviceOptions">
//             <div className="PlumberService-optionGroup">
//               <label htmlFor="showerRepair">Shower Repair</label>
//               <select
//                 id="showerRepair"
//                 onChange={(e) => setShowerRepair(parseInt(e.target.value))}
//               >
//                 <option value="0" defaultValue>
//                   0
//                 </option>
//                 <option value="1">1 Unit</option>
//                 <option value="2">2 Units</option>
//               </select>
//             </div>
//             <div className="PlumberService-optionGroup">
//               <label htmlFor="drainCleaning">Drain Cleaning</label>
//               <select
//                 id="drainCleaning"
//                 onChange={(e) => setDrainCleaning(parseInt(e.target.value))}
//               >
//                 <option value="0" defaultValue>
//                   0
//                 </option>
//                 <option value="1">1 Area</option>
//                 <option value="2">2 Areas</option>
//               </select>
//             </div>
//             {/* <div className="PlumberService-optionGroup">
//               <label>Estimated Price</label>
//               <input type="text" readOnly value={`${calculatePrice()} tk`} />
//             </div> */}

//             <div className="PlumberService-optionGroup">
//              <label htmlFor="pipeCleaning">Pipe Cleaning</label>
//              <select
//                id="pipeCleaning"
//                value={pipeCleaning}
//                onChange={(e) => setPipeCleaning(parseInt(e.target.value))}
//              >
//                <option value="0" defaultValue>0</option>
//                <option value="1">1 Pipe</option>
//                <option value="2">2 Pipes</option>
//                <option value="3">3 Pipes</option>
//              </select>
//            </div>

//            <div className="PlumberService-optionGroup">
//              <label htmlFor="tankCleaning">Tank Cleaning</label>
//              <select
//                id="tankCleaning"
//                value={tankCleaning}
//                onChange={(e) => setTankCleaning(parseInt(e.target.value))}
//              >
//                <option value="0" defaultValue>0</option>
//                <option value="1">1 Tank</option>
//                <option value="2">2 Tanks</option>
//              </select>
//            </div>

//            <div className="PlumberService-optionGroup">
//              <label htmlFor="issueCheckup">Issue Checkup?</label>
//              <select
//                id="issueCheckup"
//                value={issueCheckup ? "yes" : "no"}
//                onChange={(e) => setIssueCheckup(e.target.value === "yes")}
//              >
//                <option value="no" defaultValue>No</option>
//                <option value="yes">Yes</option>
//              </select>
//            </div>

//           </div>

//           <div className="PlumberService-priceDisplay">
//             <span>Estimated Price: {calculatePrice()} tk</span>
//             {/* <small>(Final price may vary based on complexity)</small> */}
//             {/* <label>Estimated Price</label>
//               <input type="text" readOnly value={`${calculatePrice()} tk`} /> */}
//           </div>

//           <div className="PlumberService-bookingDetails">
//             <div className="PlumberService-optionGroup">
//               <label htmlFor="date">Preferred Date</label>
//               <div className="PlumberService-dateInputWrapper">
//                 <DatePicker
//                   selected={selectedDate}
//                   onChange={(date) => setSelectedDate(date)}
//                   dateFormat="dd-MMM-yyyy"
//                   minDate={new Date()}
//                   placeholderText="Select a date"
//                   className="PlumberService-dateInput"
//                 />
//                 <FaCalendarAlt
//                   className="PlumberService-dateIcon"
//                   onClick={() =>
//                     document
//                       .querySelector(".react-datepicker__input-container input")
//                       .click()
//                   }
//                 />
//               </div>
//             </div>
//             <div className="PlumberService-optionGroup">
//               <label htmlFor="time">Preferred Time</label>
//               <select id="time" name="time" required>
//                 {generateTimeSlots(selectedDate).map((slot, idx) => (
//                   <option key={idx} value={slot}>
//                     {slot}
//                   </option>
//                 ))}
//               </select>
//             </div>
//           </div>

//           <button type="submit" className="PlumberService-actionBtn">
//             {/* Book Service Now */}
//             {rebookState ? 'Confirm Rebooking' : 'Book Service Now'}
//           </button>
//         </form>

//         {/* Info Box */}
//         <div className="PlumberService-infoBox">
//           <h4>About Our Plumber Services</h4>
//           <p>
//             Our certified plumbers deliver comprehensive installation, repair,
//             and maintenance services to keep your plumbing systems running
//             smoothly. Whether you need a new installation or repair services, we
//             guarantee expert solutions for residential and commercial needs.
//           </p>
//         </div>

//         {/* Additional Info Section */}
//         <div className="PlumberService-additionalInfo">
//           {/* How to Place an Order */}
//           <div className="PlumberService-sectionCard">
//             <h2 className="PlumberService-sectionTitle">
//               How to Place an Order
//             </h2>
//             <ol className="PlumberService-stepList">
//               <li>Select the plumbing services you need.</li>
//               <li>Choose your preferred date and time slot.</li>
//               <li>Log in or create an account if you haven't already.</li>
//               <li>Review your order details and submit your request.</li>
//               <li>
//                 Track your order in the "Order History" section for real-time
//                 updates.
//               </li>
//             </ol>
//           </div>

//           {/* Why Choose HelpNao & Key Features */}
//           <div className="PlumberService-row2col">
//             <div className="PlumberService-sectionCard PlumberService-gradientBg2">
//               <h2 className="PlumberService-sectionTitle">Why Choose HelpNao</h2>
//               <p className="PlumberService-sectionText">
//                 HelpNao connects you with highly skilled, background-checked
//                 plumbing professionals. Our commitment to transparent pricing
//                 and quick response times ensures your plumbing issues are
//                 resolved efficiently.
//               </p>
//               <div className="PlumberService-featureGrid">
//                 <div className="PlumberService-featureItem">
//                   <i
//                     className="fas fa-wrench PlumberService-featureIcon"
//                     aria-hidden="true"
//                   ></i>
//                   <p>Transparent pricing with no hidden fees</p>
//                 </div>
//                 <div className="PlumberService-featureItem">
//                   <i
//                     className="fas fa-user-check PlumberService-featureIcon"
//                     aria-hidden="true"
//                   ></i>
//                   <p>Certified and experienced professionals</p>
//                 </div>
//                 <div className="PlumberService-featureItem">
//                   <i
//                     className="fas fa-clock PlumberService-featureIcon"
//                     aria-hidden="true"
//                   ></i>
//                   <p>Quick response times</p>
//                 </div>
//                 <div className="PlumberService-featureItem">
//                   <i
//                     className="fas fa-thumbs-up PlumberService-featureIcon"
//                     aria-hidden="true"
//                   ></i>
//                   <p>High customer satisfaction</p>
//                 </div>
//               </div>
//             </div>

//             <div className="PlumberService-sectionCard PlumberService-gradientBg">
//               <h2 className="PlumberService-sectionTitle">
//                 Key Features of Our Services
//               </h2>
//               <div className="PlumberService-featureGrid">
//                 <div className="PlumberService-featureItem">
//                   <i
//                     className="fas fa-check-circle PlumberService-featureIcon"
//                     aria-hidden="true"
//                   ></i>
//                   <p>24/7 emergency support</p>
//                 </div>
//                 <div className="PlumberService-featureItem">
//                   <i
//                     className="fas fa-shield-alt PlumberService-featureIcon"
//                     aria-hidden="true"
//                   ></i>
//                   <p>Background-checked professionals</p>
//                 </div>
//                 <div className="PlumberService-featureItem">
//                   <i
//                     className="fas fa-hand-holding-water PlumberService-featureIcon"
//                     aria-hidden="true"
//                   ></i>
//                   <p>State-of-the-art tools and equipment</p>
//                 </div>
//                 <div className="PlumberService-featureItem">
//                   <i
//                     className="fas fa-shield-alt PlumberService-featureIcon"
//                     aria-hidden="true"
//                   ></i>
//                   <p>30-day service guarantee for all repairs</p>
//                 </div>
//                 <div className="PlumberService-featureItem">
//                   <i
//                     className="fas fa-headset PlumberService-featureIcon"
//                     aria-hidden="true"
//                   ></i>
//                   <p>Responsive customer support</p>
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Order Tracking */}
//           <div className="PlumberService-sectionCard PlumberService-gradientBg3">
//             <h2 className="PlumberService-sectionTitle">
//               Order Tracking &amp; History
//             </h2>
//             <div className="PlumberService-orderTrackIcon">
//               <i className="fas fa-file-alt" aria-hidden="true"></i>
//             </div>
//             <p className="PlumberService-sectionText PlumberService-centerText">
//               After placing an order, track your service status and review your
//               order details in the "Order History" section.
//             </p>
//           </div>
//         </div>
//       </div>

//       {showOrderForm && (
//         <PlumberOrderForm
//           onClose={() => setShowOrderForm(false)}
//           onSubmit={handleOrderSubmit}
//           formData={formData}
//           user={user}
//         />
//       )}

//       {showLoginPrompt && (
//         <PromptLoginCard onClose={() => setShowLoginPrompt(false)} />
//       )}
//     </div>
//   );
// };

// export default Plumber;

// ************** New update here with new features of plumber- Checked All Okay (19-6-25) ***************** //

// import React, { useState, useEffect, useMemo } from 'react';
// import { useLocation } from 'react-router-dom';
// import Navbar from '../../../Components/Navbar';
// import axios from 'axios';
// import { jwtDecode } from 'jwt-decode';
// import { URL } from '../../../config';
// import DatePicker from 'react-datepicker';
// import 'react-datepicker/dist/react-datepicker.css';
// import { FaCalendarAlt } from 'react-icons/fa';

// import PlumberOrderForm from './PlumberOrderForm';
// import PromptLoginCard from '../PromptLoginCard';

// import heroImage from '../images/plumber1.png';

// import './plumberStyle.css';

// const Plumber = () => {
//   const location    = useLocation();
//   const rebookState = location.state?.fromRebook || false;     // detect rebook flag
//   const prevOrder   = useMemo(
//     () => location.state?.previousOrder || {},
//     [location.state?.previousOrder]
//   );

//   // Service options for Plumber
//   const [toiletInstall, setToiletInstall] = useState(0);
//   const [faucetInstall, setFaucetInstall] = useState(0);
//   const [sinkInstall, setSinkInstall] = useState(0);
//   const [dishwasherInstall, setDishwasherInstall] = useState(0);
//   const [leakRepair, setLeakRepair] = useState(0);
//   const [faucetRepair, setFaucetRepair] = useState(0);
//   const [toiletRepair, setToiletRepair] = useState(0);
//   const [showerRepair, setShowerRepair] = useState(0);
//   const [drainCleaning, setDrainCleaning] = useState(0);
//   const [pipeCleaning, setPipeCleaning] = useState(0);
//   const [tankCleaning, setTankCleaning] = useState(0);
//   const [issueCheckup, setIssueCheckup] = useState(false);

//   const [showOrderForm, setShowOrderForm] = useState(false);
//   const [showLoginPrompt, setShowLoginPrompt] = useState(false);
//   const [user, setUser] = useState(null);
//   const [formData, setFormData] = useState({});

//   // const [selectedDate, setSelectedDate] = useState(new Date());

//   const getInitialDate = () => {
//       const now = new Date();
//       const currentHour = now.getHours();
//       // If current time is before 7:00 AM or after 9:00 PM, set date to tomorrow
//       if (currentHour < 7 || currentHour >= 21) {
//         const tomorrow = new Date();
//         tomorrow.setDate(now.getDate() + 1);
//         return tomorrow;
//       }
//       return now;
//     };

//   const [selectedDate, setSelectedDate] = useState(getInitialDate());

//   useEffect(() => {
//     if (rebookState) {
//       setToiletInstall(prevOrder.Toilet_in       || 0);
//       setFaucetInstall(prevOrder.Faucet_in       || 0);
//       setSinkInstall(prevOrder.Sink_in           || 0);
//       setDishwasherInstall(prevOrder.Dishwasher_in || 0);
//       setLeakRepair(prevOrder.Leak_repair        || 0);
//       setFaucetRepair(prevOrder.Faucet_repair    || 0);
//       setToiletRepair(prevOrder.Toilet_repair    || 0);
//       setShowerRepair(prevOrder.Shower_repair    || 0);
//       setDrainCleaning(prevOrder.Drain_cleaning  || 0);
//       setPipeCleaning(prevOrder.pipe_cleaning    || 0);
//       setTankCleaning(prevOrder.tank_cleaning    || 0);
//       setIssueCheckup(prevOrder.issue_checkup    || false);
//     }
//   }, [rebookState, prevOrder]);

//   // Fetch user data if token exists
//   useEffect(() => {
//     const fetchUserData = async () => {
//       try {
//         const token = localStorage.getItem('token');
//         if (token) {
//           const decodedToken = jwtDecode(token);
//           const userId = decodedToken.Id;
//           const extractedUserId = userId.startsWith('user-')
//             ? userId.split('user-')[1]
//             : userId;
//           const response = await axios.get(`${URL}/user/${extractedUserId}`, {
//             headers: { Authorization: `Bearer ${token}` }
//           });
//           setUser(response.data);
//         }
//       } catch (error) {
//         console.error('Error fetching user data:', error);
//       }
//     };
//     fetchUserData();
//     window.scrollTo(0, 0);
//   }, []);

//   // Generate time slots from 7:00 AM to 9:30 PM similar to Electrician service
//   // const generateTimeSlots = (dateObj) => {
//   //   const startTime = 7;
//   //   const endTime = 21;
//   //   const slots = [];
//   //   const now = new Date();

//   //   const todayStr = now.toISOString().split('T')[0];
//   //   let selectedDateStr = '';
//   //   if (dateObj) {
//   //     selectedDateStr = dateObj.toISOString().split('T')[0];
//   //   }

//   //   let startHour = startTime;
//   //   let startMinute = 0;
//   //   if (selectedDateStr === todayStr) {
//   //     const currentHour = now.getHours();
//   //     const currentMinute = now.getMinutes();
//   //     if (currentHour >= startTime && currentHour < endTime) {
//   //       if (currentMinute > 0 && currentMinute <= 30) {
//   //         startHour = currentHour;
//   //         startMinute = 30;
//   //       } else if (currentMinute > 30) {
//   //         startHour = currentHour + 1;
//   //         startMinute = 0;
//   //       } else {
//   //         startHour = currentHour;
//   //         startMinute = 0;
//   //       }
//   //     } else if (currentHour >= endTime) {
//   //       return [];
//   //     }
//   //   }

//   //   for (let hour = startHour; hour <= endTime; hour++) {
//   //     const minuteStart = hour === startHour ? startMinute : 0;
//   //     for (let minute = minuteStart; minute < 60; minute += 30) {
//   //       if (selectedDateStr === todayStr) {
//   //         const slotTime = new Date();
//   //         slotTime.setHours(hour, minute, 0, 0);
//   //         if (slotTime <= now) continue;
//   //       }
//   //       const displayHour = hour > 12 ? hour - 12 : hour;
//   //       const ampm = hour >= 12 ? 'PM' : 'AM';
//   //       const formattedTime = `${displayHour}:${String(minute).padStart(2, '0')} ${ampm}`;
//   //       slots.push(formattedTime);
//   //     }
//   //   }
//   //   return slots;
//   // };

//   const generateTimeSlots = (dateObj) => {
//     const startTime = 7;
//     const endTime = 21;
//     const slots = [];
//     const now = new Date();
//     const todayStr = now.toISOString().split('T')[0];
//     const selectedDateStr = dateObj ? dateObj.toISOString().split('T')[0] : '';

//     let startHour = startTime;
//     let startMinute = 0;

//     // If the selected date is today, adjust slots based on current time
//     if (selectedDateStr === todayStr) {
//       const currentHour = now.getHours();
//       const currentMinute = now.getMinutes();
//       if (currentHour >= endTime) {
//         return []; // No slots available for today
//       }
//       if (currentHour >= startTime) {
//         // Round up to the next half-hour
//         if (currentMinute > 0 && currentMinute <= 30) {
//           startHour = currentHour;
//           startMinute = 30;
//         } else if (currentMinute > 30) {
//           startHour = currentHour + 1;
//           startMinute = 0;
//         } else {
//           startHour = currentHour;
//           startMinute = 0;
//         }
//       }
//     }

//     for (let hour = startHour; hour <= endTime; hour++) {
//       const minuteStart = hour === startHour ? startMinute : 0;
//       for (let minute = minuteStart; minute < 60; minute += 30) {
//         // Skip past slots for today
//         if (selectedDateStr === todayStr) {
//           const slotTime = new Date(now);
//           slotTime.setHours(hour, minute, 0, 0);
//           if (slotTime <= now) continue;
//         }
//         const displayHour = hour > 12 ? hour - 12 : hour;
//         const ampm = hour >= 12 ? 'PM' : 'AM';
//         const formattedTime = `${displayHour}:${String(minute).padStart(2, '0')} ${ampm}`;
//         slots.push(formattedTime);
//       }
//     }
//     return slots;
//   };

//   // Calculate price based on plumber service selections
//   const calculatePrice = () => {
//     let price = 300; // Base price
//     price += toiletInstall * 250;
//     price += faucetInstall * 100;
//     price += sinkInstall * 200;
//     price += dishwasherInstall * 200;
//     price += leakRepair * 500;
//     price += faucetRepair * 100;
//     price += toiletRepair * 100;
//     price += showerRepair * 100;
//     price += drainCleaning * 150;
//     price += pipeCleaning * 300;
//     price += tankCleaning * 800;
//     price += issueCheckup ? 250 : 0;
//     return price;
//   };

//   // Handle form submission
//   const handleGetService = (e) => {
//     e.preventDefault();
//     let dateStr = '';
//     if (selectedDate) {
//       dateStr = selectedDate.toISOString().split('T')[0];
//     }
//     const time = e.target.time.value;

//     const formDetails = {
//       toiletInstall,
//       faucetInstall,
//       sinkInstall,
//       dishwasherInstall,
//       leakRepair,
//       faucetRepair,
//       toiletRepair,
//       showerRepair,
//       drainCleaning,
//       pipeCleaning,
//       tankCleaning,
//       issueCheckup,
//       price: calculatePrice(),
//       date: dateStr,
//       time
//     };
//     setFormData(formDetails);

//     // Show order form if user is logged in; otherwise prompt login
//     if (user) {
//       setShowOrderForm(true);
//     } else {
//       setShowLoginPrompt(true);
//     }
//   };

//   const handleOrderSubmit = (orderData) => {
//     console.log('Order Data:', orderData);
//     setShowOrderForm(false);
//   };

//   // PlusMinusInput Component
//   const PlusMinusInput = ({ id, value, setValue, min = 0, max = Infinity }) => {
//     const handleIncrement = () => {
//       if (value < max) setValue(value + 1);
//     };
//     const handleDecrement = () => {
//       if (value > min) setValue(value - 1);
//     };
//     const displayText = `${value} ${value === 1 ? 'unit' : 'units'}`;

//     return (
//       <div className="PlumberService-plusMinusInput">
//         <button
//           type="button"
//           className="PlumberService-minusBtn"
//           onClick={handleDecrement}
//           disabled={value <= min}
//         >
//           −
//         </button>
//         <span className="PlumberService-valueDisplay">{displayText}</span>
//         <button
//           type="button"
//           className="PlumberService-plusBtn"
//           onClick={handleIncrement}
//           disabled={value >= max}
//         >
//           +
//         </button>
//       </div>
//     );
//   };

//   return (
//     <div className="PlumberService-container">
//       <Navbar />

//       {/* Service Card */}
//       <div className="PlumberService-card">
//         {/* Hero Section */}
//         <div className="PlumberService-hero">
//           <img src={heroImage} alt="Plumber Services Hero" />
//         </div>

//         <div className="PlumberService-header">
//           {/* <h1>Professional Plumber Services</h1> */}
//           <h1>
//             {rebookState
//               ? 'Rebook Plumber Service'
//               : 'Professional Plumber Services'}
//           </h1>
//           <div className="PlumberService-rating">★★★★★</div>
//           <div className="PlumberService-reviews">45,000 Verified Reviews</div>
//         </div>

//         {/* Categories / Info Blocks */}
//         <div className="PlumberService-categories">
//           <div className="PlumberService-category">
//             <h5>
//               <span className="PlumberService-categoryIcon">🚽</span> Toilet
//               Installation &amp; Repair
//             </h5>
//             <p className="PlumberService-serviceDescription">
//               Expert installation and repair for toilets ensuring efficient
//               performance and durability.
//             </p>
//           </div>
//           <div className="PlumberService-category">
//             <h5>
//               <span className="PlumberService-categoryIcon">🚰</span> Faucet,
//               Sink &amp; Dishwasher Services
//             </h5>
//             <p className="PlumberService-serviceDescription">
//               Professional installation of faucets, sinks, and dishwashers to
//               optimize your water flow.
//             </p>
//           </div>
//           <div className="PlumberService-category">
//             <h5>
//               <span className="PlumberService-categoryIcon">💧</span> Leak,
//               Shower &amp; Drain Solutions
//             </h5>
//             <p className="PlumberService-serviceDescription">
//               Timely leak detection, shower repair, and drain cleaning to
//               prevent water damage.
//             </p>
//           </div>
//         </div>

//         {/* The Service Form */}
//         <form onSubmit={handleGetService} className="PlumberService-form">
//           {/* Installation Section */}
//           <h3 className="PlumberService-sectionTitle">
//             <i className="fas fa-toilet" /> Installation Services
//           </h3>
//           <div className="PlumberService-serviceOptions">
//             <div className="PlumberService-optionGroup">
//               <label htmlFor="toiletInstall">Toilet Installation</label>
//               <PlusMinusInput id="toiletInstall" value={toiletInstall} setValue={setToiletInstall} max={3} />
//             </div>
//             <div className="PlumberService-optionGroup">
//               <label htmlFor="faucetInstall">Faucet Installation</label>
//               <PlusMinusInput id="faucetInstall" value={faucetInstall} setValue={setFaucetInstall} max={3} />
//             </div>
//             <div className="PlumberService-optionGroup">
//               <label htmlFor="sinkInstall">Sink Installation</label>
//               <PlusMinusInput id="sinkInstall" value={sinkInstall} setValue={setSinkInstall} max={3} />
//             </div>
//             <div className="PlumberService-optionGroup">
//               <label htmlFor="dishwasherInstall">Dishwasher Installation</label>
//               <PlusMinusInput id="dishwasherInstall" value={dishwasherInstall} setValue={setDishwasherInstall} max={3} />
//             </div>
//           </div>

//           {/* Repairs Section */}
//           <h3 className="PlumberService-sectionTitle">
//             <i className="fas fa-wrench" /> Repair Services
//           </h3>
//           <div className="PlumberService-serviceOptions">
//             <div className="PlumberService-optionGroup">
//               <label htmlFor="leakRepair">Leak Repair</label>
//               <PlusMinusInput id="leakRepair" value={leakRepair} setValue={setLeakRepair} max={3} />
//             </div>
//             <div className="PlumberService-optionGroup">
//               <label htmlFor="faucetRepair">Faucet Repair</label>
//               <PlusMinusInput id="faucetRepair" value={faucetRepair} setValue={setFaucetRepair} max={3} />
//             </div>
//             <div className="PlumberService-optionGroup">
//               <label htmlFor="toiletRepair">Toilet Repair</label>
//               <PlusMinusInput id="toiletRepair" value={toiletRepair} setValue={setToiletRepair} max={3} />
//             </div>
//             <div className="PlumberService-optionGroup">
//               <label htmlFor="showerRepair">Shower Repair</label>
//               <PlusMinusInput id="showerRepair" value={showerRepair} setValue={setShowerRepair} max={3} />
//             </div>
//           </div>

//           {/* Cleaning & Checkup Section */}
//           <h3 className="PlumberService-sectionTitle">
//             <i className="fas fa-tint" /> Cleaning & Checkup
//           </h3>
//           <div className="PlumberService-serviceOptions">
//             <div className="PlumberService-optionGroup">
//               <label htmlFor="drainCleaning">Drain Cleaning</label>
//               <PlusMinusInput id="drainCleaning" value={drainCleaning} setValue={setDrainCleaning} max={3} />
//             </div>
//             <div className="PlumberService-optionGroup">
//               <label htmlFor="pipeCleaning">Pipe Cleaning</label>
//               <PlusMinusInput id="pipeCleaning" value={pipeCleaning} setValue={setPipeCleaning} max={3} />
//             </div>
//             <div className="PlumberService-optionGroup">
//               <label htmlFor="tankCleaning">Tank Cleaning</label>
//               <PlusMinusInput id="tankCleaning" value={tankCleaning} setValue={setTankCleaning} max={2} />
//             </div>
//             <div className="PlumberService-optionGroup">
//               <label htmlFor="issueCheckup">Issue Checkup</label>
//               <select
//                 id="issueCheckup"
//                 value={issueCheckup ? 'yes' : 'no'}
//                 onChange={(e) => setIssueCheckup(e.target.value === 'yes')}
//               >
//                 <option value="no">Not Needed</option>
//                 <option value="yes">Required</option>
//               </select>
//             </div>
//           </div>

//           <div className="PlumberService-priceDisplay">
//             <span>Estimated Price: {calculatePrice()} tk</span>
//             {/* <small>(Final price may vary based on complexity)</small> */}
//             {/* <label>Estimated Price</label>
//               <input type="text" readOnly value={`${calculatePrice()} tk`} /> */}
//           </div>

//           <div className="PlumberService-bookingDetails">
//             <div className="PlumberService-optionGroup">
//               <label htmlFor="date">Preferred Date</label>
//               <div className="PlumberService-dateInputWrapper">
//                 <DatePicker
//                   selected={selectedDate}
//                   onChange={(date) => setSelectedDate(date)}
//                   dateFormat="dd-MMM-yyyy"
//                   minDate={new Date()}
//                   placeholderText="Select a date"
//                   className="PlumberService-dateInput"
//                 />
//                 <FaCalendarAlt
//                   className="PlumberService-dateIcon"
//                   onClick={() =>
//                     document
//                       .querySelector(".react-datepicker__input-container input")
//                       .click()
//                   }
//                 />
//               </div>
//             </div>
//             <div className="PlumberService-optionGroup">
//               <label htmlFor="time">Preferred Time</label>
//               <select id="time" name="time" required>
//                 {generateTimeSlots(selectedDate).map((slot, idx) => (
//                   <option key={idx} value={slot}>
//                     {slot}
//                   </option>
//                 ))}
//               </select>
//             </div>
//           </div>

//           <button type="submit" className="PlumberService-actionBtn">
//             {/* Book Service Now */}
//             {rebookState ? 'Confirm Rebooking' : 'Book Service Now'}
//           </button>
//         </form>

//         {/* Info Box */}
//         <div className="PlumberService-infoBox">
//           <h4>About Our Plumber Services</h4>
//           <p>
//             Our certified plumbers deliver comprehensive installation, repair,
//             and maintenance services to keep your plumbing systems running
//             smoothly. Whether you need a new installation or repair services, we
//             guarantee expert solutions for residential and commercial needs.
//           </p>
//         </div>

//         {/* Additional Info Section */}
//         <div className="PlumberService-additionalInfo">
//           {/* How to Place an Order */}
//           <div className="PlumberService-sectionCard">
//             <h2 className="PlumberService-sectionTitle">
//               How to Place an Order
//             </h2>
//             <ol className="PlumberService-stepList">
//               <li>Select the plumbing services you need.</li>
//               <li>Choose your preferred date and time slot.</li>
//               <li>Log in or create an account if you haven't already.</li>
//               <li>Review your order details and submit your request.</li>
//               <li>
//                 Track your order in the "Order History" section for real-time
//                 updates.
//               </li>
//             </ol>
//           </div>

//           {/* Why Choose HelpNao & Key Features */}
//           <div className="PlumberService-row2col">
//             <div className="PlumberService-sectionCard PlumberService-gradientBg2">
//               <h2 className="PlumberService-sectionTitle">Why Choose HelpNao</h2>
//               <p className="PlumberService-sectionText">
//                 HelpNao connects you with highly skilled, background-checked
//                 plumbing professionals. Our commitment to transparent pricing
//                 and quick response times ensures your plumbing issues are
//                 resolved efficiently.
//               </p>
//               <div className="PlumberService-featureGrid">
//                 <div className="PlumberService-featureItem">
//                   <i
//                     className="fas fa-wrench PlumberService-featureIcon"
//                     aria-hidden="true"
//                   ></i>
//                   <p>Transparent pricing with no hidden fees</p>
//                 </div>
//                 <div className="PlumberService-featureItem">
//                   <i
//                     className="fas fa-user-check PlumberService-featureIcon"
//                     aria-hidden="true"
//                   ></i>
//                   <p>Certified and experienced professionals</p>
//                 </div>
//                 <div className="PlumberService-featureItem">
//                   <i
//                     className="fas fa-clock PlumberService-featureIcon"
//                     aria-hidden="true"
//                   ></i>
//                   <p>Quick response times</p>
//                 </div>
//                 <div className="PlumberService-featureItem">
//                   <i
//                     className="fas fa-thumbs-up PlumberService-featureIcon"
//                     aria-hidden="true"
//                   ></i>
//                   <p>High customer satisfaction</p>
//                 </div>
//               </div>
//             </div>

//             <div className="PlumberService-sectionCard PlumberService-gradientBg">
//               <h2 className="PlumberService-sectionTitle">
//                 Key Features of Our Services
//               </h2>
//               <div className="PlumberService-featureGrid">
//                 <div className="PlumberService-featureItem">
//                   <i
//                     className="fas fa-check-circle PlumberService-featureIcon"
//                     aria-hidden="true"
//                   ></i>
//                   <p>24/7 emergency support</p>
//                 </div>
//                 <div className="PlumberService-featureItem">
//                   <i
//                     className="fas fa-shield-alt PlumberService-featureIcon"
//                     aria-hidden="true"
//                   ></i>
//                   <p>Background-checked professionals</p>
//                 </div>
//                 <div className="PlumberService-featureItem">
//                   <i
//                     className="fas fa-hand-holding-water PlumberService-featureIcon"
//                     aria-hidden="true"
//                   ></i>
//                   <p>State-of-the-art tools and equipment</p>
//                 </div>
//                 <div className="PlumberService-featureItem">
//                   <i
//                     className="fas fa-shield-alt PlumberService-featureIcon"
//                     aria-hidden="true"
//                   ></i>
//                   <p>30-day service guarantee for all repairs</p>
//                 </div>
//                 <div className="PlumberService-featureItem">
//                   <i
//                     className="fas fa-headset PlumberService-featureIcon"
//                     aria-hidden="true"
//                   ></i>
//                   <p>Responsive customer support</p>
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Order Tracking */}
//           <div className="PlumberService-sectionCard PlumberService-gradientBg3">
//             <h2 className="PlumberService-sectionTitle">
//               Order Tracking &amp; History
//             </h2>
//             <div className="PlumberService-orderTrackIcon">
//               <i className="fas fa-file-alt" aria-hidden="true"></i>
//             </div>
//             <p className="PlumberService-sectionText PlumberService-centerText">
//               After placing an order, track your service status and review your
//               order details in the "Order History" section.
//             </p>
//           </div>
//         </div>
//       </div>

//       {showOrderForm && (
//         <PlumberOrderForm
//           onClose={() => setShowOrderForm(false)}
//           onSubmit={handleOrderSubmit}
//           formData={formData}
//           user={user}
//         />
//       )}

//       {showLoginPrompt && (
//         <PromptLoginCard onClose={() => setShowLoginPrompt(false)} />
//       )}
//     </div>
//   );
// };

// export default Plumber;

// ***** Upper code All checked and okay (19-6-25) ***** //




// ***** Add Translate EN-BN with new updated (19-6-25) ***** //

// import React, { useState, useEffect, useMemo } from "react";
// import { useLocation } from "react-router-dom";
// import Navbar from "../../../Components/Navbar";
// import axios from "axios";
// import { jwtDecode } from "jwt-decode";
// import { URL } from "../../../config";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
// import {
//   FaCalendarAlt,
//   FaStar,
//   FaStarHalfAlt,
//   FaRegStar,
// } from "react-icons/fa";
// import { useTranslation } from "react-i18next";

// import PlumberOrderForm from "./PlumberOrderForm";
// import PromptLoginCard from "../PromptLoginCard";

// import heroImage from "../images/plumber1.png";

// import "./plumberStyle.css";
// import FeedbackPage from "../../Feedback/FeedbackPage";
// import Footer from "../../../Components/Footer/Footer";
// import ServiceTooltip from "../../../Components/Tooltip/ServiceTooltip";
// import Loader from "../../../Components/LoaderSpin/Loader";

// const Plumber = () => {
//   const { t } = useTranslation();

//   const [ratingData, setRatingData] = useState({
//     reviewCount: 0,
//     avgRating: 0,
//   });

//   const location = useLocation();
//   const rebookState = location.state?.fromRebook || false; // detect rebook flag
//   const prevOrder = useMemo(
//     () => location.state?.previousOrder || {},
//     [location.state?.previousOrder]
//   );

//   // Service options for Plumber
//   const [useSameServitor, setUseSameServitor] = useState(false); //new added for same servitor rebook
//   const [prevServitorName, setPrevServitorName] = useState(""); //new added for same servitor rebook

//   const [toiletInstall, setToiletInstall] = useState(0);
//   const [faucetInstall, setFaucetInstall] = useState(0);
//   const [sinkInstall, setSinkInstall] = useState(0);
//   const [dishwasherInstall, setDishwasherInstall] = useState(0);
//   const [leakRepair, setLeakRepair] = useState(0);
//   const [faucetRepair, setFaucetRepair] = useState(0);
//   const [toiletRepair, setToiletRepair] = useState(0);
//   const [showerRepair, setShowerRepair] = useState(0);
//   const [drainCleaning, setDrainCleaning] = useState(0);
//   const [pipeCleaning, setPipeCleaning] = useState(0);
//   const [tankCleaning, setTankCleaning] = useState(0);
//   const [geyserSetup, setGeyserSetup]     = useState(0);
//   const [geyserRepair, setGeyserRepair]   = useState(0);
//   const [issueCheckup, setIssueCheckup] = useState(false);

//   const [remarks, setRemarks] = useState("");

//   const [showOrderForm, setShowOrderForm] = useState(false);
//   const [showLoginPrompt, setShowLoginPrompt] = useState(false);
//   const [user, setUser] = useState(null);
//   const [formData, setFormData] = useState({});
//   const [loading, setLoading] = useState(false);
  
  

//   // const [selectedDate, setSelectedDate] = useState(new Date());

//   const getInitialDate = () => {
//     const now = new Date();
//     const currentHour = now.getHours();
//     // If current time is before 7:00 AM or after 9:00 PM, set date to tomorrow
//     if (currentHour < 7 || currentHour >= 21) {
//       const tomorrow = new Date();
//       tomorrow.setDate(now.getDate() + 1);
//       return tomorrow;
//     }
//     return now;
//   };

//   const [selectedDate, setSelectedDate] = useState(getInitialDate());

//   useEffect(() => {
//     if (rebookState) {
//       setToiletInstall(prevOrder.Toilet_in || 0);
//       setFaucetInstall(prevOrder.Faucet_in || 0);
//       setSinkInstall(prevOrder.Sink_in || 0);
//       setDishwasherInstall(prevOrder.Dishwasher_in || 0);
//       setLeakRepair(prevOrder.Leak_repair || 0);
//       setFaucetRepair(prevOrder.Faucet_repair || 0);
//       setToiletRepair(prevOrder.Toilet_repair || 0);
//       setShowerRepair(prevOrder.Shower_repair || 0);
//       setDrainCleaning(prevOrder.Drain_cleaning || 0);
//       setPipeCleaning(prevOrder.pipe_cleaning || 0);
//       setTankCleaning(prevOrder.tank_cleaning || 0);
//       setIssueCheckup(prevOrder.issue_checkup || false);
//     }
//   }, [rebookState, prevOrder]);

//   // Fetch user data if token exists
//   useEffect(() => {
//     const fetchUserData = async () => {
//       try {
//         setLoading(true);
//         const token = localStorage.getItem("token");
//         if (token) {
//           const decodedToken = jwtDecode(token);
//           const userId = decodedToken.Id;
//           const extractedUserId = userId.startsWith("user-")
//             ? userId.split("user-")[1]
//             : userId;
//           const response = await axios.get(`${URL}/user/${extractedUserId}`, {
//             headers: { Authorization: `Bearer ${token}` },
//           });
//           setUser(response.data);
//         }
//       } catch (error) {
//         console.error("Error fetching user data:", error);
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchUserData();
//     window.scrollTo(0, 0);
//   }, []);

//   //new added for same servitor rebook
//   useEffect(() => {
//     if (rebookState && prevOrder.servitor_id) {
//       axios
//         .get(`${URL}/servitors/${prevOrder.servitor_id}`)
//         .then((res) => {
//           const s = res.data;
//           setPrevServitorName(`${s.FirstName} ${s.LastName}`);
//         })
//         .catch((err) => console.error("Error fetching servitor:", err));
//     }
//   }, [rebookState, prevOrder.servitor_id]);

//   // Fetch only Plumber ratings once
//   // useEffect(() => {
//   //   axios
//   //     .get(`${URL}/api/ratings`)
//   //     .then(({ data }) => {
//   //       const { plumber } = data;
//   //       setRatingData({
//   //         reviewCount: plumber.reviewCount,
//   //         avgRating: plumber.avgRating,
//   //       });
//   //     })
//   //     .catch((err) => console.error("Failed to load ratings:", err));
//   // }, []);

//   useEffect(() => {
//       const loadRatings = async () => {
//         try {
//           setLoading(true);
//           const { data } = await axios.get(`${URL}/api/ratings`);
//           const { plumber = {} } = data;
//           setRatingData({
//             reviewCount: plumber.reviewCount || 0,
//             avgRating: plumber.avgRating || 0,
//           });
//         } catch (err) {
//           console.error("Failed to load ratings:", err);
//         } finally {
//           setLoading(false);
//         }
//       };
//       loadRatings();
//     }, []);

//   const renderStars = (rating) => {
//     const stars = [];
//     for (let i = 1; i <= 5; i++) {
//       if (rating >= i) {
//         stars.push(<FaStar key={i} />);
//       } else if (rating >= i - 0.5) {
//         stars.push(<FaStarHalfAlt key={i} />);
//       } else {
//         stars.push(<FaRegStar key={i} />);
//       }
//     }
//     return stars;
//   };

//   // Generate time slots from 7:00 AM to 9:30 PM similar to Electrician service
//   // const generateTimeSlots = (dateObj) => {
//   //   const startTime = 7;
//   //   const endTime = 21;
//   //   const slots = [];
//   //   const now = new Date();

//   //   const todayStr = now.toISOString().split('T')[0];
//   //   let selectedDateStr = '';
//   //   if (dateObj) {
//   //     selectedDateStr = dateObj.toISOString().split('T')[0];
//   //   }

//   //   let startHour = startTime;
//   //   let startMinute = 0;
//   //   if (selectedDateStr === todayStr) {
//   //     const currentHour = now.getHours();
//   //     const currentMinute = now.getMinutes();
//   //     if (currentHour >= startTime && currentHour < endTime) {
//   //       if (currentMinute > 0 && currentMinute <= 30) {
//   //         startHour = currentHour;
//   //         startMinute = 30;
//   //       } else if (currentMinute > 30) {
//   //         startHour = currentHour + 1;
//   //         startMinute = 0;
//   //       } else {
//   //         startHour = currentHour;
//   //         startMinute = 0;
//   //       }
//   //     } else if (currentHour >= endTime) {
//   //       return [];
//   //     }
//   //   }

//   //   for (let hour = startHour; hour <= endTime; hour++) {
//   //     const minuteStart = hour === startHour ? startMinute : 0;
//   //     for (let minute = minuteStart; minute < 60; minute += 30) {
//   //       if (selectedDateStr === todayStr) {
//   //         const slotTime = new Date();
//   //         slotTime.setHours(hour, minute, 0, 0);
//   //         if (slotTime <= now) continue;
//   //       }
//   //       const displayHour = hour > 12 ? hour - 12 : hour;
//   //       const ampm = hour >= 12 ? 'PM' : 'AM';
//   //       const formattedTime = `${displayHour}:${String(minute).padStart(2, '0')} ${ampm}`;
//   //       slots.push(formattedTime);
//   //     }
//   //   }
//   //   return slots;
//   // };

//   const generateTimeSlots = (dateObj) => {
//     const startTime = 7;
//     const endTime = 21;
//     const slots = [];
//     const now = new Date();
//     const todayStr = now.toISOString().split("T")[0];
//     const selectedDateStr = dateObj ? dateObj.toISOString().split("T")[0] : "";

//     let startHour = startTime;
//     let startMinute = 0;

//     // If the selected date is today, adjust slots based on current time
//     if (selectedDateStr === todayStr) {
//       const currentHour = now.getHours();
//       const currentMinute = now.getMinutes();
//       if (currentHour >= endTime) {
//         return []; // No slots available for today
//       }
//       if (currentHour >= startTime) {
//         // Round up to the next half-hour
//         if (currentMinute > 0 && currentMinute <= 30) {
//           startHour = currentHour;
//           startMinute = 30;
//         } else if (currentMinute > 30) {
//           startHour = currentHour + 1;
//           startMinute = 0;
//         } else {
//           startHour = currentHour;
//           startMinute = 0;
//         }
//       }
//     }

//     for (let hour = startHour; hour <= endTime; hour++) {
//       const minuteStart = hour === startHour ? startMinute : 0;
//       for (let minute = minuteStart; minute < 60; minute += 30) {
//         // Skip past slots for today
//         if (selectedDateStr === todayStr) {
//           const slotTime = new Date(now);
//           slotTime.setHours(hour, minute, 0, 0);
//           if (slotTime <= now) continue;
//         }
//         const displayHour = hour > 12 ? hour - 12 : hour;
//         const ampm = hour >= 12 ? "PM" : "AM";
//         const formattedTime = `${displayHour}:${String(minute).padStart(
//           2,
//           "0"
//         )} ${ampm}`;
//         slots.push(formattedTime);
//       }
//     }
//     return slots;
//   };

//   // Calculate price based on plumber service selections
//   const calculatePrice = () => {
//     let price = 300; // Base price
//     price += toiletInstall * 250;
//     price += faucetInstall * 100;
//     price += sinkInstall * 200;
//     price += dishwasherInstall * 200;
//     price += leakRepair * 500;
//     price += faucetRepair * 100;
//     price += toiletRepair * 100;
//     price += showerRepair * 100;
//     price += drainCleaning * 150;
//     price += pipeCleaning * 300;
//     price += tankCleaning * 800;
//     price += geyserSetup * 1200;
//     price += geyserRepair *  800;
//     price += issueCheckup ? 250 : 0;
//     return price;
//   };

//   // Handle form submission
//   const handleGetService = (e) => {
//     e.preventDefault();
//     let dateStr = "";
//     if (selectedDate) {
//       dateStr = selectedDate.toISOString().split("T")[0];
//     }
//     const time = e.target.time.value;

//     const formDetails = {
//       toiletInstall,
//       faucetInstall,
//       sinkInstall,
//       dishwasherInstall,
//       leakRepair,
//       faucetRepair,
//       toiletRepair,
//       showerRepair,
//       drainCleaning,
//       pipeCleaning,
//       tankCleaning,
//       geyserSetup,
//       geyserRepair,
//       issueCheckup,

//       remarks,

//       price: calculatePrice(),
//       date: dateStr,
//       time,

//       // new added for rebook same servitor
//       useSameServitor,
//       servitor_id: useSameServitor
//         ? prevOrder.servitor_id // carry through the original servitor’s ID
//         : undefined,
//     };
//     setFormData(formDetails);

//     // Show order form if user is logged in; otherwise prompt login
//     if (user) {
//       setShowOrderForm(true);
//     } else {
//       setShowLoginPrompt(true);
//     }
//   };

//   const handleOrderSubmit = (orderData) => {
//     console.log("Order Data:", orderData);
//     setShowOrderForm(false);

//     // reset every service‐option to its initial default:
//     setToiletInstall(0);
//     setFaucetInstall(0);
//     setSinkInstall(0);
//     setDishwasherInstall(0);
//     setLeakRepair(0);
//     setFaucetRepair(0);
//     setToiletRepair(0);
//     setShowerRepair(0);
//     setDrainCleaning(0);
//     setPipeCleaning(0);
//     setTankCleaning(0);
//     setGeyserSetup(0);
//     setGeyserRepair(0);
//     setIssueCheckup(false);
//     setRemarks("");
//     setUseSameServitor(false);
//     setFormData({});
//   };

//   // PlusMinusInput Component
//   const PlusMinusInput = ({ id, value, setValue, min = 0, max = Infinity }) => {
//     const handleIncrement = () => {
//       if (value < max) setValue(value + 1);
//     };
//     const handleDecrement = () => {
//       if (value > min) setValue(value - 1);
//     };
//     const displayText = `${value} ${value === 1 ? "unit" : "units"}`;

//     return (
//       <div className="PlumberService-plusMinusInput">
//         <button
//           type="button"
//           className="PlumberService-minusBtn"
//           onClick={handleDecrement}
//           disabled={value <= min}
//         >
//           −
//         </button>
//         <span className="PlumberService-valueDisplay">{displayText}</span>
//         <button
//           type="button"
//           className="PlumberService-plusBtn"
//           onClick={handleIncrement}
//           disabled={value >= max}
//         >
//           +
//         </button>
//       </div>
//     );
//   };

//   return (
//     <>
//       <div className="PlumberService-container">
//         <Navbar />
//         <Loader show={loading} />
        
//         {/* Service Card */}
//         <div className="PlumberService-card">
//           {/* Hero Section */}
//           <div className="PlumberService-hero">
//             <img src={heroImage} alt="Plumber Services Hero" />
//           </div>

//           <div className="PlumberService-header">
//             <h1>
//               {/* {rebookState ? 'Rebook Plumber Service' : 'Professional Plumber Services'} */}
//               {t(
//                 rebookState
//                   ? "plumber.header.rebook_title"
//                   : "plumber.header.title"
//               )}{" "}
//               {/* CHANGED: Added translation */}
//             </h1>
//             {/* <div className="PlumberService-rating">★★★★★</div>
//           <div className="PlumberService-reviews">45,000 Verified Reviews</div> */}

//             <div className="PlumberService-rating">
//               {renderStars(ratingData.avgRating)}
//             </div>
//             <div className="PlumberService-reviews">
//               {ratingData.reviewCount.toLocaleString()}{" "}
//               {t("plumber.reviewsLabel")}
//             </div>
//           </div>

//           <div className="PlumberService-categories">
//             <div className="PlumberService-category">
//               <h5>
//                 <span className="PlumberService-categoryIcon">🚽</span>
//                 {/* Toilet Installation & Repair */}
//                 {t("plumber.categories.toilet_services.title")}{" "}
//                 {/* CHANGED: Added translation */}
//               </h5>
//               <p className="PlumberService-serviceDescription">
//                 {/* Expert installation and repair for toilets ensuring efficient performance and durability. */}
//                 {t("plumber.categories.toilet_services.description")}{" "}
//                 {/* CHANGED: Added translation */}
//               </p>
//             </div>
//             <div className="PlumberService-category">
//               <h5>
//                 <span className="PlumberService-categoryIcon">🚰</span>
//                 {/* Faucet, Sink & Dishwasher Services */}
//                 {t("plumber.categories.faucet_sink_dishwasher.title")}{" "}
//                 {/* CHANGED: Added translation */}
//               </h5>
//               <p className="PlumberService-serviceDescription">
//                 {/* Professional installation of faucets, sinks, and dishwashers to optimize your water flow. */}
//                 {t("plumber.categories.faucet_sink_dishwasher.description")}{" "}
//                 {/* CHANGED: Added translation */}
//               </p>
//             </div>
//             <div className="PlumberService-category">
//               <h5>
//                 <span className="PlumberService-categoryIcon">💧</span>
//                 {/* Leak, Shower & Drain Solutions */}
//                 {t("plumber.categories.leak_shower_drain.title")}{" "}
//                 {/* CHANGED: Added translation */}
//               </h5>
//               <p className="PlumberService-serviceDescription">
//                 {/* Timely leak detection, shower repair, and drain cleaning to prevent water damage. */}
//                 {t("plumber.categories.leak_shower_drain.description")}{" "}
//                 {/* CHANGED: Added translation */}
//               </p>
//             </div>
//           </div>

//           <form onSubmit={handleGetService} className="PlumberService-form">
//             <h3 className="PlumberService-sectionTitle">
//               <i className="fas fa-toilet" />
//               {/* Installation Services */}
//               {t("plumber.form.sections.installation_services.title")}{" "}
//               {/* CHANGED: Added translation */}
//             </h3>
//             <div className="PlumberService-serviceOptions">
//               <div className="PlumberService-optionGroup">
//                 <label htmlFor="toiletInstall" className="tooltip-label">
//                                   {/* Toilet Installation */}
//                                   {t(
//                                     "plumber.form.sections.installation_services.labels.toilet_install"
//                                   )}{" "}
//                                   {/* CHANGED: Added translation */}
//                                   <ServiceTooltip
//                                     title={t("plumber.tooltips.toilet_install.title") || "Toilet Installation"}
//                                     description={t("plumber.tooltips.toilet_install.description") || "When you need this service:\n• Setting up a new toilet in your bathroom during renovations\n• Replacing an old or damaged toilet for better efficiency\n• Ensuring secure connections to prevent leaks and proper flushing"}
//                                   />
//                                 </label>
//                 <PlusMinusInput
//                   id="toiletInstall"
//                   value={toiletInstall}
//                   setValue={setToiletInstall}
//                   // max={3}
//                 />
//               </div>
//               <div className="PlumberService-optionGroup">
//                 <label htmlFor="faucetInstall" className="tooltip-label">
//                                   {/* Faucet Installation */}
//                                   {t(
//                                     "plumber.form.sections.installation_services.labels.faucet_install"
//                                   )}{" "}
//                                   {/* CHANGED: Added translation */}
//                                   <ServiceTooltip
//                                     title={t("plumber.tooltips.faucet_install.title") || "Faucet Installation"}
//                                     description={t("plumber.tooltips.faucet_install.description") || "When you need this service:\n• Mounting a new faucet in sinks or basins for updated style\n• Upgrading to touchless or water-saving models in kitchens or bathrooms\n• Connecting securely to water lines without drips or pressure issues"}
//                                   />
//                                 </label>
//                 <PlusMinusInput
//                   id="faucetInstall"
//                   value={faucetInstall}
//                   setValue={setFaucetInstall}
//                   // max={3}
//                 />
//               </div>
//               <div className="PlumberService-optionGroup">
//                 <label htmlFor="sinkInstall" className="tooltip-label">
//                                   {/* Sink Installation */}
//                                   {t(
//                                     "plumber.form.sections.installation_services.labels.sink_install"
//                                   )}{" "}
//                                   {/* CHANGED: Added translation */}
//                                   <ServiceTooltip
//                                     title={t("plumber.tooltips.sink_install.title") || "Sink Installation"}
//                                     description={t("plumber.tooltips.sink_install.description") || "When you need this service:\n• Fitting a new sink in kitchen or bathroom countertops\n• Replacing old sinks to improve drainage and aesthetics\n• Sealing edges and connecting plumbing for leak-proof performance"}
//                                   />
//                                 </label>
//                 <PlusMinusInput
//                   id="sinkInstall"
//                   value={sinkInstall}
//                   setValue={setSinkInstall}
//                   // max={3}
//                 />
//               </div>
//               <div className="PlumberService-optionGroup">
//                 <label htmlFor="dishwasherInstall" className="tooltip-label">
//                                   {/* Dishwasher Installation */}
//                                   {t(
//                                     "plumber.form.sections.installation_services.labels.dishwasher_install"
//                                   )}{" "}
//                                   {/* CHANGED: Added translation */}
//                                   <ServiceTooltip
//                                     title={t("plumber.tooltips.dishwasher_install.title") || "Dishwasher Installation"}
//                                     description={t("plumber.tooltips.dishwasher_install.description") || "When you need this service:\n• Hooking up a new dishwasher to water supply and drainage\n• Integrating under counter or freestanding models seamlessly\n• Testing connections to ensure quiet operation and no leaks"}
//                                   />
//                                 </label>
//                 <PlusMinusInput
//                   id="dishwasherInstall"
//                   value={dishwasherInstall}
//                   setValue={setDishwasherInstall}
//                   // max={3}
//                 />
//               </div>

//               <div className="PlumberService-optionGroup">
//                 <label htmlFor="geyserSetup" className="tooltip-label">
//                                   {t("plumber.form.sections.installation_services.labels.geyser_setup")}
//                                   <ServiceTooltip
//                                     title={t("plumber.tooltips.geyser_setup.title") || "Geyser Setup"}
//                                     description={t("plumber.tooltips.geyser_setup.description") || "When you need this service:\n• Installing a new water heater or geyser in bathrooms or kitchens\n• Connecting to power and water lines with safety valves\n• Ensuring efficient hot water supply without pressure buildup"}
//                                   />
//                                 </label>
//                 <PlusMinusInput
//                   id="geyserSetup"
//                   value={geyserSetup}
//                   setValue={setGeyserSetup}
//                 />
//               </div>

//             </div>

//             <h3 className="PlumberService-sectionTitle">
//               <i className="fas fa-wrench" />
//               {/* Repair Services */}
//               {t("plumber.form.sections.repair_services.title")}{" "}
//               {/* CHANGED: Added translation */}
//             </h3>
//             <div className="PlumberService-serviceOptions">
//               <div className="PlumberService-optionGroup">
//                 <label htmlFor="leakRepair" className="tooltip-label">
//                                   {/* Leak Repair */}
//                                   {t(
//                                     "plumber.form.sections.repair_services.labels.leak_repair"
//                                   )}{" "}
//                                   {/* CHANGED: Added translation */}
//                                   <ServiceTooltip
//                                     title={t("plumber.tooltips.leak_repair.title") || "Leak Repair"}
//                                     description={t("plumber.tooltips.leak_repair.description") || "When you need this service:\n• Fixing drips from pipes, joints, or fixtures to save water\n• Detecting hidden leaks behind walls or under floors\n• Replacing seals or sections to restore tight, efficient plumbing"}
//                                   />
//                                 </label>
//                 <PlusMinusInput
//                   id="leakRepair"
//                   value={leakRepair}
//                   setValue={setLeakRepair}
//                   // max={3}
//                 />
//               </div>
//               <div className="PlumberService-optionGroup">
//                 <label htmlFor="faucetRepair" className="tooltip-label">
//                                   {/* Faucet Repair */}
//                                   {t(
//                                     "plumber.form.sections.repair_services.labels.faucet_repair"
//                                   )}{" "}
//                                   {/* CHANGED: Added translation */}
//                                   <ServiceTooltip
//                                     title={t("plumber.tooltips.faucet_repair.title") || "Faucet Repair"}
//                                     description={t("plumber.tooltips.faucet_repair.description") || "When you need this service:\n• Resolving low flow, sputtering, or constant dripping in faucets\n• Replacing washers, cartridges, or aerators for smooth operation\n• Tightening handles and bases to prevent wobbling or leaks"}
//                                   />
//                                 </label>
//                 <PlusMinusInput
//                   id="faucetRepair"
//                   value={faucetRepair}
//                   setValue={setFaucetRepair}
//                   // max={3}
//                 />
//               </div>
//               <div className="PlumberService-optionGroup">
//                 <label htmlFor="toiletRepair" className="tooltip-label">
//                                   {/* Toilet Repair */}
//                                   {t(
//                                     "plumber.form.sections.repair_services.labels.toilet_repair"
//                                   )}{" "}
//                                   {/* CHANGED: Added translation */}
//                                   <ServiceTooltip
//                                     title={t("plumber.tooltips.toilet_repair.title") || "Toilet Repair"}
//                                     description={t("plumber.tooltips.toilet_repair.description") || "When you need this service:\n• Fixing running water, weak flushes, or clogged mechanisms\n• Adjusting fill valves, flappers, or chains for reliable function\n• Clearing blockages to restore proper waste disposal"}
//                                   />
//                                 </label>
//                 <PlusMinusInput
//                   id="toiletRepair"
//                   value={toiletRepair}
//                   setValue={setToiletRepair}
//                   // max={3}
//                 />
//               </div>
//               <div className="PlumberService-optionGroup">
//                 <label htmlFor="showerRepair" className="tooltip-label">
//                                   {/* Shower Repair */}
//                                   {t(
//                                     "plumber.form.sections.repair_services.labels.shower_repair"
//                                   )}{" "}
//                                   {/* CHANGED: Added translation */}
//                                   <ServiceTooltip
//                                     title={t("plumber.tooltips.shower_repair.title") || "Shower Repair"}
//                                     description={t("plumber.tooltips.shower_repair.description") || "When you need this service:\n• Addressing low pressure, temperature fluctuations, or leaks in showerheads\n• Replacing diverters, hoses, or valves for consistent water flow\n• Fixing drain clogs to prevent standing water and backups"}
//                                   />
//                                 </label>
//                 <PlusMinusInput
//                   id="showerRepair"
//                   value={showerRepair}
//                   setValue={setShowerRepair}
//                   // max={3}
//                 />
//               </div>

//               <div className="PlumberService-optionGroup">
//                 <label htmlFor="geyserRepair" className="tooltip-label">
//                                   {t("plumber.form.sections.repair_services.labels.geyser_repair")}
//                                   <ServiceTooltip
//                                     title={t("plumber.tooltips.geyser_repair.title") || "Geyser Repair"}
//                                     description={t("plumber.tooltips.geyser_repair.description") || "When you need this service:\n• Troubleshooting no hot water, strange noises, or leaks in geysers\n• Replacing heating elements, thermostats, or safety valves\n• Draining and flushing to remove sediment for longer lifespan"}
//                                   />
//                                 </label>
//                 <PlusMinusInput
//                   id="geyserRepair"
//                   value={geyserRepair}
//                   setValue={setGeyserRepair}
//                 />
//               </div>
//             </div>

//             <h3 className="PlumberService-sectionTitle">
//               <i className="fas fa-tint" />
//               {/* Cleaning & Checkup */}
//               {t("plumber.form.sections.cleaning_checkup.title")}{" "}
//               {/* CHANGED: Added translation */}
//             </h3>
//             <div className="PlumberService-serviceOptions">
//               <div className="PlumberService-optionGroup">
//                 <label htmlFor="drainCleaning" className="tooltip-label">
//                                   {/* Drain Cleaning */}
//                                   {t(
//                                     "plumber.form.sections.cleaning_checkup.labels.drain_cleaning"
//                                   )}{" "}
//                                   {/* CHANGED: Added translation */}
//                                   <ServiceTooltip
//                                     title={t("plumber.tooltips.drain_cleaning.title") || "Drain Cleaning"}
//                                     description={t("plumber.tooltips.drain_cleaning.description") || "When you need this service:\n• Clearing slow drains or complete blockages in sinks and showers\n• Using snakes or hydro-jetting to remove hair, grease, or debris\n• Preventing overflows and odors with thorough pipe flushing"}
//                                   />
//                                 </label>
//                 <PlusMinusInput
//                   id="drainCleaning"
//                   value={drainCleaning}
//                   setValue={setDrainCleaning}
//                   // max={3}
//                 />
//               </div>
//               <div className="PlumberService-optionGroup">
//                 <label htmlFor="pipeCleaning" className="tooltip-label">
//                                   {/* Pipe Cleaning */}
//                                   {t(
//                                     "plumber.form.sections.cleaning_checkup.labels.pipe_cleaning"
//                                   )}{" "}
//                                   {/* CHANGED: Added translation */}
//                                   <ServiceTooltip
//                                     title={t("plumber.tooltips.pipe_cleaning.title") || "Pipe Cleaning"}
//                                     description={t("plumber.tooltips.pipe_cleaning.description") || "When you need this service:\n• Flushing internal pipe buildup of scale, rust, or minerals\n• Inspecting for corrosion and applying protective treatments\n• Improving water quality and flow to avoid future clogs"}
//                                   />
//                                 </label>
//                 <PlusMinusInput
//                   id="pipeCleaning"
//                   value={pipeCleaning}
//                   setValue={setPipeCleaning}
//                   // max={3}
//                 />
//               </div>
//               <div className="PlumberService-optionGroup">
//                 <label htmlFor="tankCleaning" className="tooltip-label">
//                                   {/* Tank Cleaning */}
//                                   {t(
//                                     "plumber.form.sections.cleaning_checkup.labels.tank_cleaning"
//                                   )}{" "}
//                                   {/* CHANGED: Added translation */}
//                                   <ServiceTooltip
//                                     title={t("plumber.tooltips.tank_cleaning.title") || "Tank Cleaning"}
//                                     description={t("plumber.tooltips.tank_cleaning.description") || "When you need this service:\n• Draining and scrubbing overhead or underground water tanks\n• Removing sediment, algae, and bacteria for safe drinking water\n• Disinfecting and refilling to maintain hygiene and capacity"}
//                                   />
//                                 </label>
//                 <PlusMinusInput
//                   id="tankCleaning"
//                   value={tankCleaning}
//                   setValue={setTankCleaning}
//                   // max={2}
//                 />
//               </div>
//               <div className="PlumberService-optionGroup">
//                 <label htmlFor="issueCheckup" className="tooltip-label">
//                                   {/* Issue Checkup */}
//                                   {t(
//                                     "plumber.form.sections.cleaning_checkup.labels.issue_checkup"
//                                   )}{" "}
//                                   {/* CHANGED: Added translation */}
//                                   <ServiceTooltip
//                                     title={t("plumber.tooltips.issue_checkup.title") || "Issue Checkup"}
//                                     description={t("plumber.tooltips.issue_checkup.description") || "When you need this service:\n• Inspecting your entire plumbing system for hidden leaks or wear\n• Diagnosing low pressure, unusual noises, or discolored water\n• Providing a report with recommendations to prevent major breakdowns"}
//                                   />
//                                 </label>
//                 <select
//                   id="issueCheckup"
//                   value={issueCheckup ? "yes" : "no"}
//                   onChange={(e) => setIssueCheckup(e.target.value === "yes")}
//                 >
//                   <option value="no">
//                     {/* Not Needed */}
//                     {t(
//                       "plumber.form.sections.cleaning_checkup.issue_checkup_options.not_needed"
//                     )}{" "}
//                     {/* CHANGED: Added translation */}
//                   </option>
//                   <option value="yes">
//                     {/* Required */}
//                     {t(
//                       "plumber.form.sections.cleaning_checkup.issue_checkup_options.required"
//                     )}{" "}
//                     {/* CHANGED: Added translation */}
//                   </option>
//                 </select>
//               </div>
//             </div>

//             {/* New added Rebook same servitor */}
//             {rebookState && prevServitorName && (
//               <div className="rebook-same-servitor">
//                 <label>
//                   <input
//                     type="checkbox"
//                     checked={useSameServitor}
//                     onChange={() => setUseSameServitor(!useSameServitor)}
//                   />
//                   {/* {t('electrician.form.rebook_same_servitor')} */}
//                   {/* {` Do you want to book ${prevServitorName} again?`} */}
//                   <span className="rebook-text">
//                     {t("plumber.form.rebook_same_servitor_prefix")}
//                     <span className="strong-name">{prevServitorName}</span>
//                     {t("plumber.form.rebook_same_servitor_suffix")}
//                   </span>
//                 </label>
//               </div>
//             )}

//             <div className="PlumberService-priceDisplay">
//               <span>
//                 {/* Estimated Price: {calculatePrice()} tk */}
//                 {t("plumber.form.price_display", {
//                   price: calculatePrice(),
//                 })}{" "}
//                 {/* CHANGED: Added translation */}
//               </span>
//             </div>

//             {/* Pricing note banner */}
//               <div className="PlumberService-priceNote" role="note" aria-live="polite">
//                 <div className="PlumberService-priceNote-icon" aria-hidden="true">
//                   {/* small star icon (inline SVG) */}
//                   <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor">
//                     <path d="M12 17.27 18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/>
//                   </svg>
//                 </div>
//                 <div className="PlumberService-priceNote-content">
//                   <div className="PlumberService-priceNote-title">
//                     {t("plumber.price_note.title")}
//                   </div>
//                   <p className="PlumberService-priceNote-text">
//                     <strong>{t("plumber.price_note.service_charges_only_label")}</strong>{" "}
//                     {t("plumber.price_note.body")}
//                   </p>
//                 </div>
//               </div>


//             <div className="PlumberService-bookingDetails">
//               <div className="PlumberService-optionGroup">
//                 <label htmlFor="date">
//                   {/* Preferred Date */}
//                   {t("plumber.form.booking_details.labels.date")}{" "}
//                   {/* CHANGED: Added translation */}
//                 </label>
//                 <div className="PlumberService-dateInputWrapper">
//                   <DatePicker
//                     selected={selectedDate}
//                     onChange={(date) => setSelectedDate(date)}
//                     dateFormat="dd-MMM-yyyy"
//                     minDate={new Date()}
//                     placeholderText={t(
//                       "plumber.form.booking_details.date_placeholder"
//                     )} // CHANGED: Added translation for placeholder
//                     className="PlumberService-dateInput"
//                   />
//                   <FaCalendarAlt
//                     className="PlumberService-dateIcon"
//                     onClick={() =>
//                       document
//                         .querySelector(
//                           ".react-datepicker__input-container input"
//                         )
//                         .click()
//                     }
//                   />
//                 </div>
//               </div>
//               <div className="PlumberService-optionGroup">
//                 <label htmlFor="time">
//                   {/* Preferred Time */}
//                   {t("plumber.form.booking_details.labels.time")}{" "}
//                   {/* CHANGED: Added translation */}
//                 </label>
//                 <select id="time" name="time" required>
//                   {generateTimeSlots(selectedDate).map((slot, idx) => (
//                     <option key={idx} value={slot}>
//                       {slot}
//                     </option>
//                   ))}
//                 </select>
//               </div>
//             </div>

//             {/* <h3 className="PlumberService-sectionTitle">
//             <i className="fas fa-comment-alt"></i>
//             {t("electrician.form.remarks_title")}{" "}
//           </h3> */}
//             <div className="PlumberService-serviceOptions">
//               <div className="PlumberService-optionGroup PlumberService-fullWidth">
//                 <label htmlFor="remarks">
//                   <i className="fas fa-comment-alt"></i>
//                   {t("electrician.form.labels.remarks")}
//                 </label>
//                 <textarea
//                   id="remarks"
//                   value={remarks}
//                   onChange={(e) => setRemarks(e.target.value)}
//                   placeholder={t("electrician.form.placeholders.remarks")}
//                   className="PlumberService-textarea"
//                   rows="2"
//                 />
//               </div>
//             </div>

//             <button type="submit" className="PlumberService-actionBtn">
//               {/* {rebookState ? 'Confirm Rebooking' : 'Book Service Now'} */}
//               {t(
//                 rebookState
//                   ? "plumber.form.rebook_button"
//                   : "plumber.form.submit_button"
//               )}{" "}
//               {/* CHANGED: Added translation */}
//             </button>
//           </form>

//           <div className="PlumberService-infoBox">
//             <h4>
//               {/* About Our Plumber Services */}
//               {t("plumber.info_box.title")} {/* CHANGED: Added translation */}
//             </h4>
//             <p>
//               {/* Our certified plumbers deliver comprehensive installation, repair, and maintenance services... */}
//               {t("plumber.info_box.description")}{" "}
//               {/* CHANGED: Added translation */}
//             </p>
//           </div>

//           <div className="PlumberService-additionalInfo">
//             <div className="PlumberService-sectionCard">
//               <h2 className="PlumberService-sectionTitle">
//                 {/* How to Place an Order */}
//                 {t("plumber.additional_info.how_to_place_order.title")}{" "}
//                 {/* CHANGED: Added translation */}
//               </h2>
//               <ol className="PlumberService-stepList">
//                 {t("plumber.additional_info.how_to_place_order.steps", {
//                   returnObjects: true,
//                 }).map((step, index) => (
//                   <li key={index}>{step}</li>
//                 ))}
//               </ol>
//             </div>

//             <div className="PlumberService-row2col">
//               <div className="PlumberService-sectionCard PlumberService-gradientBg2">
//                 <h2 className="PlumberService-sectionTitle">
//                   {/* Why Choose HelpNao */}
//                   {t("plumber.additional_info.why_choose_HelpNao.title")}{" "}
//                   {/* CHANGED: Added translation */}
//                 </h2>
//                 <p className="PlumberService-sectionText">
//                   {/* HelpNao connects you with highly skilled, background-checked plumbing professionals... */}
//                   {t("plumber.additional_info.why_choose_HelpNao.description")}{" "}
//                   {/* CHANGED: Added translation */}
//                 </p>
//                 <div className="PlumberService-featureGrid">
//                   {t("plumber.additional_info.why_choose_HelpNao.features", {
//                     returnObjects: true,
//                   }).map((feature, index) => (
//                     <div className="PlumberService-featureItem" key={index}>
//                       <i
//                         className={`fas fa-${
//                           index === 0
//                             ? "wrench"
//                             : index === 1
//                             ? "user-check"
//                             : index === 2
//                             ? "clock"
//                             : "thumbs-up"
//                         } PlumberService-featureIcon`}
//                         aria-hidden="true"
//                       ></i>
//                       <p>{feature}</p>
//                     </div>
//                   ))}
//                 </div>
//               </div>

//               <div className="PlumberService-sectionCard PlumberService-gradientBg">
//                 <h2 className="PlumberService-sectionTitle">
//                   {/* Key Features of Our Services */}
//                   {t("plumber.additional_info.key_features.title")}{" "}
//                   {/* CHANGED: Added translation */}
//                 </h2>
//                 <div className="PlumberService-featureGrid">
//                   {t("plumber.additional_info.key_features.features", {
//                     returnObjects: true,
//                   }).map((feature, index) => (
//                     <div className="PlumberService-featureItem" key={index}>
//                       <i
//                         className={`fas fa-${
//                           index === 0
//                             ? "check-circle"
//                             : index === 1
//                             ? "shield-alt"
//                             : index === 2
//                             ? "hand-holding-water"
//                             : index === 3
//                             ? "shield-alt"
//                             : "headset"
//                         } PlumberService-featureIcon`}
//                         aria-hidden="true"
//                       ></i>
//                       <p>{feature}</p>
//                     </div>
//                   ))}
//                 </div>
//               </div>
//             </div>

//             <div className="PlumberService-sectionCard PlumberService-gradientBg3">
//               <h2 className="PlumberService-sectionTitle">
//                 {/* Order Tracking & History */}
//                 {t("plumber.additional_info.order_tracking.title")}{" "}
//                 {/* CHANGED: Added translation */}
//               </h2>
//               <div className="PlumberService-orderTrackIcon">
//                 <i className="fas fa-file-alt" aria-hidden="true"></i>
//               </div>
//               <p className="PlumberService-sectionText PlumberService-centerText">
//                 {/* After placing an order, track your service status and review your order details... */}
//                 {t("plumber.additional_info.order_tracking.description")}{" "}
//                 {/* CHANGED: Added translation */}
//               </p>
//             </div>
//           </div>
//         </div>

//         {showOrderForm && (
//           <PlumberOrderForm
//             onClose={() => setShowOrderForm(false)}
//             onSubmit={handleOrderSubmit}
//             formData={formData}
//             user={user}
//             previousServitorName={prevServitorName}
//           />
//         )}

//         {showLoginPrompt && (
//           <PromptLoginCard onClose={() => setShowLoginPrompt(false)} />
//         )}
//       </div>

//       {/* Add Feedback Section */}
//       <div className="PlumberService-feedback-section">
//         <FeedbackPage serviceType="Plumber" />
//       </div>

//       <Footer />
//     </>
//   );
// };

// export default Plumber;





// ***** Update with new features (23-Oct-2025) ***** //

import React, { useState, useEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "../../../Components/Navbar";
import axios from "axios";
import { jwtDecode } from "jwt-decode";
import { URL } from "../../../config";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
  FaCalendarAlt,
  FaStar,
  FaStarHalfAlt,
  FaRegStar,
} from "react-icons/fa";
import { useTranslation } from "react-i18next";

import PlumberOrderForm from "./PlumberOrderForm";
import PromptLoginCard from "../PromptLoginCard";

import heroImage from "../images/Plumber-service-banner.png";

import "./plumberStyle.css";
import FeedbackPage from "../../Feedback/FeedbackPage";
import Footer from "../../../Components/Footer/Footer";
import ServiceTooltip from "../../../Components/Tooltip/ServiceTooltip";
import Loader from "../../../Components/LoaderSpin/Loader";
import { PLUMBER_PRICING } from "../servicePricing";
import SEO from "../../../Components/SEO/SEO";

const P = PLUMBER_PRICING;
// const BASE_FEE = Number(P?.base ?? 0);
const CHECKUP_FEE = Number(P?.issueCheckupFlat ?? 0);

const PLATFORM_PERCENT = Number(P?.platformFee?.percent ?? 0.05);
const PLATFORM_MIN = Number(P?.platformFee?.min ?? 50);

// helpers
const calcPlatformFee = (subtotal) => {
  const fee = subtotal * PLATFORM_PERCENT;
  return Math.max(PLATFORM_MIN, Math.round(fee));
};

const Plumber = () => {
  const { t } = useTranslation();

  const [ratingData, setRatingData] = useState({
    reviewCount: 0,
    avgRating: 0,
  });

  const location = useLocation();
  const rebookState = location.state?.fromRebook || false; // detect rebook flag
  const prevOrder = useMemo(
    () => location.state?.previousOrder || {},
    [location.state?.previousOrder]
  );

  // Service options for Plumber
  const [useSameServitor, setUseSameServitor] = useState(false); //new added for same servitor rebook
  const [prevServitorName, setPrevServitorName] = useState(""); //new added for same servitor rebook

  const [angleValveSetup, setAngleValveSetup] = useState(0);
  const [basinTapSetup, setBasinTapSetup] = useState(0);
  const [magicPipeSetup, setMagicPipeSetup] = useState(0);
  const [basinWastePopUpSetup, setBasinWastePopUpSetup] = useState(0);
  const [newBasinSetupExistingLines, setNewBasinSetupExistingLines] =
    useState(0);
  const [bathroomTapBibCockSetup, setBathroomTapBibCockSetup] = useState(0);
  const [tissueHolderSetup, setTissueHolderSetup] = useState(0);
  const [fillValveReplacement, setFillValveReplacement] = useState(0);
  const [handShowerSetup, setHandShowerSetup] = useState(0);
  const [soapDishSetup, setSoapDishSetup] = useState(0);
  const [bathroomShelfSetup, setBathroomShelfSetup] = useState(0);
  const [mirrorSetup, setMirrorSetup] = useState(0);
  const [towelHangerSetup, setTowelHangerSetup] = useState(0);
  const [showerHeadSetup, setShowerHeadSetup] = useState(0);
  const [concealedStopcockSetup, setConcealedStopcockSetup] = useState(0);
  const [floorDrainNetSetup, setFloorDrainNetSetup] = useState(0);
  const [toiletSeatCoverReplacement, setToiletSeatCoverReplacement] =
    useState(0);
  const [toiletSeatCompleteInstallation, setToiletSeatCompleteInstallation] =
    useState(0);
  const [
    highCommodeInstallationExistingLines,
    setHighCommodeInstallationExistingLines,
  ] = useState(0);
  const [blockageClearingHighCommode, setBlockageClearingHighCommode] =
    useState(0);
  const [blockageClearingLowCommode, setBlockageClearingLowCommode] =
    useState(0);
  const [bathroomDrainLineCleaning, setBathroomDrainLineCleaning] = useState(0);
  const [geyserInstallation, setGeyserInstallation] = useState(0);
  const [kitchenSinkSetupExistingLines, setKitchenSinkSetupExistingLines] =
    useState(0);
  const [sinkBlockageCleaning, setSinkBlockageCleaning] = useState(0);
  const [washingMachinePointSetup, setWashingMachinePointSetup] = useState(0);

  const [issueCheckup, setIssueCheckup] = useState(false);

  const [remarks, setRemarks] = useState("");

  const [showOrderForm, setShowOrderForm] = useState(false);
  const [showLoginPrompt, setShowLoginPrompt] = useState(false);
  const [user, setUser] = useState(null);
  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(false);

  // const [selectedDate, setSelectedDate] = useState(new Date());

  const toLocalYMD = (d) => {
    const x = new Date(d);
    const y = x.getFullYear();
    const m = String(x.getMonth() + 1).padStart(2, "0");
    const day = String(x.getDate()).padStart(2, "0");
    return `${y}-${m}-${day}`;
  };

  // const getInitialDate = () => {
  //   const now = new Date();
  //   const currentHour = now.getHours();
  //   // If current time is before 7:00 AM or after 9:00 PM, set date to tomorrow
  //   if (currentHour < 7 || currentHour >= 21) {
  //     const tomorrow = new Date();
  //     tomorrow.setDate(now.getDate() + 1);
  //     return tomorrow;
  //   }
  //   return now;
  // };

  const getInitialDate = () => {
    const now = new Date();
    const currentHour = now.getHours();

    // before 7am or after/equal 9pm -> tomorrow
    if (currentHour < 7 || currentHour >= 21) {
      const tomorrow = new Date(now);
      tomorrow.setDate(now.getDate() + 1);
      return tomorrow;
    }
    return now;
  };

  const [selectedDate, setSelectedDate] = useState(getInitialDate());

  useEffect(() => {
    if (rebookState) {
      setAngleValveSetup(prevOrder.angle_valve_setup || 0);
      setBasinTapSetup(prevOrder.basin_tap_setup || 0);
      setMagicPipeSetup(prevOrder.magic_pipe_setup || 0);
      setBasinWastePopUpSetup(prevOrder.basin_waste_pop_up_setup || 0);
      setNewBasinSetupExistingLines(
        prevOrder.new_basin_setup_existing_lines || 0
      );
      setBathroomTapBibCockSetup(prevOrder.bathroom_tap_bib_cock_setup || 0);
      setTissueHolderSetup(prevOrder.tissue_holder_setup || 0);
      setFillValveReplacement(prevOrder.fill_valve_replacement || 0);
      setHandShowerSetup(prevOrder.hand_shower_setup || 0);
      setSoapDishSetup(prevOrder.soap_dish_setup || 0);
      setBathroomShelfSetup(prevOrder.bathroom_shelf_setup || 0);
      setMirrorSetup(prevOrder.mirror_setup || 0);
      setTowelHangerSetup(prevOrder.towel_hanger_setup || 0);
      setShowerHeadSetup(prevOrder.shower_head_setup || 0);
      setConcealedStopcockSetup(prevOrder.concealed_stopcock_setup || 0);
      setFloorDrainNetSetup(prevOrder.floor_drain_net_setup || 0);
      setToiletSeatCoverReplacement(
        prevOrder.toilet_seat_cover_replacement || 0
      );
      setToiletSeatCompleteInstallation(
        prevOrder.toilet_seat_complete_installation || 0
      );
      setHighCommodeInstallationExistingLines(
        prevOrder.high_commode_installation_existing_lines || 0
      );
      setBlockageClearingHighCommode(
        prevOrder.blockage_clearing_high_commode || 0
      );
      setBlockageClearingLowCommode(
        prevOrder.blockage_clearing_low_commode || 0
      );
      setBathroomDrainLineCleaning(prevOrder.bathroom_drain_line_cleaning || 0);
      setGeyserInstallation(prevOrder.geyser_installation || 0);
      setKitchenSinkSetupExistingLines(
        prevOrder.kitchen_sink_setup_existing_lines || 0
      );
      setSinkBlockageCleaning(prevOrder.sink_blockage_cleaning || 0);
      setWashingMachinePointSetup(prevOrder.washing_machine_point_setup || 0);

      setIssueCheckup(prevOrder.issue_checkup || false);
    }
  }, [rebookState, prevOrder]);

  // Fetch user data if token exists
  useEffect(() => {
    const fetchUserData = async () => {
      try {
        setLoading(true);
        const token = localStorage.getItem("token");
        if (token) {
          const decodedToken = jwtDecode(token);
          const userId = decodedToken.Id;
          const extractedUserId = userId.startsWith("user-")
            ? userId.split("user-")[1]
            : userId;
          const response = await axios.get(`${URL}/user/${extractedUserId}`, {
            headers: { Authorization: `Bearer ${token}` },
          });
          setUser(response.data);
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchUserData();
    window.scrollTo(0, 0);
  }, []);

  //new added for same servitor rebook
  useEffect(() => {
    if (rebookState && prevOrder.servitor_id) {
      axios
        .get(`${URL}/servitors/${prevOrder.servitor_id}`)
        .then((res) => {
          const s = res.data;
          setPrevServitorName(`${s.FirstName} ${s.LastName}`);
        })
        .catch((err) => console.error("Error fetching servitor:", err));
    }
  }, [rebookState, prevOrder.servitor_id]);

  useEffect(() => {
    const loadRatings = async () => {
      try {
        setLoading(true);
        const { data } = await axios.get(`${URL}/api/ratings`);
        const { plumber = {} } = data;
        setRatingData({
          reviewCount: plumber.reviewCount || 0,
          avgRating: plumber.avgRating || 0,
        });
      } catch (err) {
        console.error("Failed to load ratings:", err);
      } finally {
        setLoading(false);
      }
    };
    loadRatings();
  }, []);

  const renderStars = (rating) => {
    const stars = [];
    for (let i = 1; i <= 5; i++) {
      if (rating >= i) {
        stars.push(<FaStar key={i} />);
      } else if (rating >= i - 0.5) {
        stars.push(<FaStarHalfAlt key={i} />);
      } else {
        stars.push(<FaRegStar key={i} />);
      }
    }
    return stars;
  };

  const generateTimeSlots = (dateObj) => {
    const startTime = 7;
    const endTime = 21;
    const slots = [];
    const now = new Date();
    // const todayStr = now.toISOString().split("T")[0];
    // const selectedDateStr = dateObj ? dateObj.toISOString().split("T")[0] : "";

    const todayStr = toLocalYMD(now);
    const selectedDateStr = dateObj ? toLocalYMD(dateObj) : "";

    let startHour = startTime;
    let startMinute = 0;

    // If the selected date is today, adjust slots based on current time
    if (selectedDateStr === todayStr) {
      const currentHour = now.getHours();
      const currentMinute = now.getMinutes();
      if (currentHour >= endTime) {
        return []; // No slots available for today
      }
      if (currentHour >= startTime) {
        // Round up to the next half-hour
        if (currentMinute > 0 && currentMinute <= 30) {
          startHour = currentHour;
          startMinute = 30;
        } else if (currentMinute > 30) {
          startHour = currentHour + 1;
          startMinute = 0;
        } else {
          startHour = currentHour;
          startMinute = 0;
        }
      }
    }

    for (let hour = startHour; hour <= endTime; hour++) {
      const minuteStart = hour === startHour ? startMinute : 0;
      for (let minute = minuteStart; minute < 60; minute += 30) {
        // Skip past slots for today
        if (selectedDateStr === todayStr) {
          const slotTime = new Date(now);
          slotTime.setHours(hour, minute, 0, 0);
          if (slotTime <= now) continue;
        }
        const displayHour = hour > 12 ? hour - 12 : hour;
        const ampm = hour >= 12 ? "PM" : "AM";
        const formattedTime = `${displayHour}:${String(minute).padStart(
          2,
          "0"
        )} ${ampm}`;
        slots.push(formattedTime);
      }
    }
    return slots;
  };

  // Price Calculate & breakdown
  // ---------- Pricing helpers ----------
  const U = (v) => Math.max(0, Number(v) || 0);
  const fmtTk = (n) => `${(Number(n) || 0).toLocaleString()} tk`;
  const unit = (key) => Number(P?.perUnit?.[key] ?? 0);

  // ── TRUE when ANY service selected (counts > 0) or checkup chosen
  const hasAnySelection = useMemo(() => {
    const counts = [
      angleValveSetup,
      basinTapSetup,
      magicPipeSetup,
      basinWastePopUpSetup,
      newBasinSetupExistingLines,
      bathroomTapBibCockSetup,
      tissueHolderSetup,
      fillValveReplacement,
      handShowerSetup,
      soapDishSetup,
      bathroomShelfSetup,
      mirrorSetup,
      towelHangerSetup,
      showerHeadSetup,
      concealedStopcockSetup,
      floorDrainNetSetup,
      toiletSeatCoverReplacement,
      toiletSeatCompleteInstallation,
      highCommodeInstallationExistingLines,
      blockageClearingHighCommode,
      blockageClearingLowCommode,
      bathroomDrainLineCleaning,
      geyserInstallation,
      kitchenSinkSetupExistingLines,
      sinkBlockageCleaning,
      washingMachinePointSetup,
    ];
    return counts.some((c) => U(c) > 0) || !!issueCheckup;
  }, [
    angleValveSetup,
    basinTapSetup,
    magicPipeSetup,
    basinWastePopUpSetup,
    newBasinSetupExistingLines,
    bathroomTapBibCockSetup,
    tissueHolderSetup,
    fillValveReplacement,
    handShowerSetup,
    soapDishSetup,
    bathroomShelfSetup,
    mirrorSetup,
    towelHangerSetup,
    showerHeadSetup,
    concealedStopcockSetup,
    floorDrainNetSetup,
    toiletSeatCoverReplacement,
    toiletSeatCompleteInstallation,
    highCommodeInstallationExistingLines,
    blockageClearingHighCommode,
    blockageClearingLowCommode,
    bathroomDrainLineCleaning,
    geyserInstallation,
    kitchenSinkSetupExistingLines,
    sinkBlockageCleaning,
    washingMachinePointSetup,
    issueCheckup,
  ]);


  // ---------- Subtotal (service charges only) ----------
    // ---------- Total price ----------
const subtotal = useMemo(() => {
  let s = 0;

  s += U(angleValveSetup) * unit("angleValveSetup");
  s += U(basinTapSetup) * unit("basinTapSetup");
  s += U(magicPipeSetup) * unit("magicPipeSetup");
  s += U(basinWastePopUpSetup) * unit("basinWastePopUpSetup");
  s += U(newBasinSetupExistingLines) * unit("newBasinSetupExistingLines");

  s += U(bathroomTapBibCockSetup) * unit("bathroomTapBibCockSetup");
  s += U(tissueHolderSetup) * unit("tissueHolderSetup");
  s += U(fillValveReplacement) * unit("fillValveReplacement");
  s += U(handShowerSetup) * unit("handShowerSetup");
  s += U(soapDishSetup) * unit("soapDishSetup");

  s += U(bathroomShelfSetup) * unit("bathroomShelfSetup");
  s += U(mirrorSetup) * unit("mirrorSetup");
  s += U(towelHangerSetup) * unit("towelHangerSetup");
  s += U(showerHeadSetup) * unit("showerHeadSetup");
  s += U(concealedStopcockSetup) * unit("concealedStopcockSetup");

  s += U(floorDrainNetSetup) * unit("floorDrainNetSetup");
  s += U(toiletSeatCoverReplacement) * unit("toiletSeatCoverReplacement");
  s += U(toiletSeatCompleteInstallation) * unit("toiletSeatCompleteInstallation");
  s += U(highCommodeInstallationExistingLines) * unit("highCommodeInstallationExistingLines");
  s += U(blockageClearingHighCommode) * unit("blockageClearingHighCommode");

  s += U(blockageClearingLowCommode) * unit("blockageClearingLowCommode");
  s += U(bathroomDrainLineCleaning) * unit("bathroomDrainLineCleaning");
  s += U(geyserInstallation) * unit("geyserInstallation");
  s += U(kitchenSinkSetupExistingLines) * unit("kitchenSinkSetupExistingLines");
  s += U(sinkBlockageCleaning) * unit("sinkBlockageCleaning");

  s += U(washingMachinePointSetup) * unit("washingMachinePointSetup");

  if (issueCheckup) s += CHECKUP_FEE;

  return Math.round(s);
}, [
  angleValveSetup,
  basinTapSetup,
  magicPipeSetup,
  basinWastePopUpSetup,
  newBasinSetupExistingLines,
  bathroomTapBibCockSetup,
  tissueHolderSetup,
  fillValveReplacement,
  handShowerSetup,
  soapDishSetup,
  bathroomShelfSetup,
  mirrorSetup,
  towelHangerSetup,
  showerHeadSetup,
  concealedStopcockSetup,
  floorDrainNetSetup,
  toiletSeatCoverReplacement,
  toiletSeatCompleteInstallation,
  highCommodeInstallationExistingLines,
  blockageClearingHighCommode,
  blockageClearingLowCommode,
  bathroomDrainLineCleaning,
  geyserInstallation,
  kitchenSinkSetupExistingLines,
  sinkBlockageCleaning,
  washingMachinePointSetup,
  issueCheckup,
]);



  // ---------- Total price (subtotal + platform fee) ----------
const calculatePrice = () => {
  if (!hasAnySelection) return 0;
  const platformFee = calcPlatformFee(subtotal);
  return Math.round(subtotal + platformFee);
};

  // ---------- Breakdown rows (AC-style) ----------
  const breakdownRows = useMemo(() => {
    const rows = [];
    const add = (label, count, key) => {
      const c = U(count);
      if (!c) return;
      const each = unit(key);
      rows.push({
        label,
        calc: `${c} × ${fmtTk(each)} =`,
        total: fmtTk(c * each),
      });
    };

    // Bathroom Fixtures & Valves
    add(
      t("plumber.breakdown.angle_valve_setup", "Angle Valve Setup"),
      angleValveSetup,
      "angleValveSetup"
    );
    add(
      t("plumber.breakdown.basin_tap_setup", "Basin Tap Setup"),
      basinTapSetup,
      "basinTapSetup"
    );
    add(
      t("plumber.breakdown.magic_pipe_setup", "Magic Pipe Setup"),
      magicPipeSetup,
      "magicPipeSetup"
    );
    add(
      t(
        "plumber.breakdown.basin_waste_pop_up_setup",
        "Basin Waste Pop Up Setup"
      ),
      basinWastePopUpSetup,
      "basinWastePopUpSetup"
    );
    add(
      t(
        "plumber.breakdown.new_basin_setup_existing_lines",
        "New Basin Setup (Existing Lines)"
      ),
      newBasinSetupExistingLines,
      "newBasinSetupExistingLines"
    );

    // Bathroom Accessories
    add(
      t(
        "plumber.breakdown.bathroom_tap_bib_cock_setup",
        "Bathroom Tap Bib Cock Setup"
      ),
      bathroomTapBibCockSetup,
      "bathroomTapBibCockSetup"
    );
    add(
      t("plumber.breakdown.tissue_holder_setup", "Tissue Holder Setup"),
      tissueHolderSetup,
      "tissueHolderSetup"
    );
    add(
      t("plumber.breakdown.fill_valve_replacement", "Fill Valve Replacement"),
      fillValveReplacement,
      "fillValveReplacement"
    );
    add(
      t("plumber.breakdown.hand_shower_setup", "Hand Shower Setup"),
      handShowerSetup,
      "handShowerSetup"
    );
    add(
      t("plumber.breakdown.soap_dish_setup", "Soap Dish Setup"),
      soapDishSetup,
      "soapDishSetup"
    );

    // Bathroom Fixtures Cont.
    add(
      t("plumber.breakdown.bathroom_shelf_setup", "Bathroom Shelf Setup"),
      bathroomShelfSetup,
      "bathroomShelfSetup"
    );
    add(
      t("plumber.breakdown.mirror_setup", "Mirror Setup"),
      mirrorSetup,
      "mirrorSetup"
    );
    add(
      t("plumber.breakdown.towel_hanger_setup", "Towel Hanger Setup"),
      towelHangerSetup,
      "towelHangerSetup"
    );
    add(
      t("plumber.breakdown.shower_head_setup", "Shower Head Setup"),
      showerHeadSetup,
      "showerHeadSetup"
    );
    add(
      t(
        "plumber.breakdown.concealed_stopcock_setup",
        "Concealed Stopcock Setup"
      ),
      concealedStopcockSetup,
      "concealedStopcockSetup"
    );

    // Drains & Toilet Accessories
    add(
      t("plumber.breakdown.floor_drain_net_setup", "Floor Drain Net Setup"),
      floorDrainNetSetup,
      "floorDrainNetSetup"
    );
    add(
      t(
        "plumber.breakdown.toilet_seat_cover_replacement",
        "Toilet Seat Cover Replacement"
      ),
      toiletSeatCoverReplacement,
      "toiletSeatCoverReplacement"
    );
    add(
      t(
        "plumber.breakdown.toilet_seat_complete_installation",
        "Toilet Seat Complete Installation"
      ),
      toiletSeatCompleteInstallation,
      "toiletSeatCompleteInstallation"
    );

    // Commode Services
    add(
      t(
        "plumber.breakdown.high_commode_installation_existing_lines",
        "High Commode Installation (Existing Lines)"
      ),
      highCommodeInstallationExistingLines,
      "highCommodeInstallationExistingLines"
    );
    add(
      t(
        "plumber.breakdown.blockage_clearing_high_commode",
        "Blockage Clearing High Commode"
      ),
      blockageClearingHighCommode,
      "blockageClearingHighCommode"
    );
    add(
      t(
        "plumber.breakdown.blockage_clearing_low_commode",
        "Blockage Clearing Low Commode"
      ),
      blockageClearingLowCommode,
      "blockageClearingLowCommode"
    );
    add(
      t(
        "plumber.breakdown.bathroom_drain_line_cleaning",
        "Bathroom Drain Line Cleaning"
      ),
      bathroomDrainLineCleaning,
      "bathroomDrainLineCleaning"
    );

    // Geyser & Kitchen
    add(
      t("plumber.breakdown.geyser_installation", "Geyser Installation"),
      geyserInstallation,
      "geyserInstallation"
    );
    add(
      t(
        "plumber.breakdown.kitchen_sink_setup_existing_lines",
        "Kitchen Sink Setup (Existing Lines)"
      ),
      kitchenSinkSetupExistingLines,
      "kitchenSinkSetupExistingLines"
    );
    add(
      t("plumber.breakdown.sink_blockage_cleaning", "Sink Blockage Cleaning"),
      sinkBlockageCleaning,
      "sinkBlockageCleaning"
    );
    add(
      t(
        "plumber.breakdown.washing_machine_point_setup",
        "Washing Machine Point Setup"
      ),
      washingMachinePointSetup,
      "washingMachinePointSetup"
    );

    // ✅ Flat issue checkup (only when chosen)
    if (issueCheckup) {
      rows.push({
        label: t("plumber.breakdown.issue_checkup", "Issue Checkup"),
        calc: "", // flat, no "×"
        total: fmtTk(CHECKUP_FEE),
      });
    }

    // ✅ Booking fee only when there is at least ONE line above
    // if (rows.length > 0 && BASE_FEE > 0) {
    //   rows.push({
    //     //  label: t("plumber.breakdown.booking_fee", "Booking Fee"),
    //     label: t(
    //       "plumber.breakdown.platform_support_fee",
    //       "Platform & Support Fee"
    //     ),
    //     calc: "",
    //     total: fmtTk(BASE_FEE),
    //   });
    // }

    // ✅ Platform & Support Fee = 5% of subtotal (min 50)
    if (rows.length > 0) {
      const platformFee = calcPlatformFee(subtotal);

      rows.push({
        label: t("plumber.breakdown.platform_support_fee", "Platform & Support Fee"),
        // calc: `${Math.round(PLATFORM_PERCENT * 100)}% (min ${fmtTk(PLATFORM_MIN)})`,
        total: fmtTk(platformFee),
      });
    }

    return rows;
  }, [
    t,
    angleValveSetup,
    basinTapSetup,
    magicPipeSetup,
    basinWastePopUpSetup,
    newBasinSetupExistingLines,
    bathroomTapBibCockSetup,
    tissueHolderSetup,
    fillValveReplacement,
    handShowerSetup,
    soapDishSetup,
    bathroomShelfSetup,
    mirrorSetup,
    towelHangerSetup,
    showerHeadSetup,
    concealedStopcockSetup,
    floorDrainNetSetup,
    toiletSeatCoverReplacement,
    toiletSeatCompleteInstallation,
    highCommodeInstallationExistingLines,
    blockageClearingHighCommode,
    blockageClearingLowCommode,
    bathroomDrainLineCleaning,
    geyserInstallation,
    kitchenSinkSetupExistingLines,
    sinkBlockageCleaning,
    washingMachinePointSetup,
    issueCheckup, // important so the row appears/disappears
    subtotal,
  ]);

  // Handle form submission
  const handleGetService = (e) => {
    e.preventDefault();
    if (!hasAnySelection) return;
    let dateStr = "";
    if (selectedDate) {
      // dateStr = selectedDate.toISOString().split("T")[0];
      dateStr = toLocalYMD(selectedDate);
    }
    const time = e.target.time.value;

    const formDetails = {
      angleValveSetup,
      basinTapSetup,
      magicPipeSetup,
      basinWastePopUpSetup,
      newBasinSetupExistingLines,
      bathroomTapBibCockSetup,
      tissueHolderSetup,
      fillValveReplacement,
      handShowerSetup,
      soapDishSetup,
      bathroomShelfSetup,
      mirrorSetup,
      towelHangerSetup,
      showerHeadSetup,
      concealedStopcockSetup,
      floorDrainNetSetup,
      toiletSeatCoverReplacement,
      toiletSeatCompleteInstallation,
      highCommodeInstallationExistingLines,
      blockageClearingHighCommode,
      blockageClearingLowCommode,
      bathroomDrainLineCleaning,
      geyserInstallation,
      kitchenSinkSetupExistingLines,
      sinkBlockageCleaning,
      washingMachinePointSetup,
      issueCheckup,

      remarks,

      price: calculatePrice(),
      date: dateStr,
      time,

      // new added for rebook same servitor
      useSameServitor,
      servitor_id: useSameServitor
        ? prevOrder.servitor_id // carry through the original servitor’s ID
        : undefined,
    };
    setFormData(formDetails);

    // Show order form if user is logged in; otherwise prompt login
    if (user) {
      setShowOrderForm(true);
    } else {
      setShowLoginPrompt(true);
    }
  };

  const handleOrderSubmit = (orderData) => {
    // console.log("Order Data:", orderData);
    setShowOrderForm(false);

    // reset every service‐option to its initial default:
    setAngleValveSetup(0);
    setBasinTapSetup(0);
    setMagicPipeSetup(0);
    setBasinWastePopUpSetup(0);
    setNewBasinSetupExistingLines(0);
    setBathroomTapBibCockSetup(0);
    setTissueHolderSetup(0);
    setFillValveReplacement(0);
    setHandShowerSetup(0);
    setSoapDishSetup(0);
    setBathroomShelfSetup(0);
    setMirrorSetup(0);
    setTowelHangerSetup(0);
    setShowerHeadSetup(0);
    setConcealedStopcockSetup(0);
    setFloorDrainNetSetup(0);
    setToiletSeatCoverReplacement(0);
    setToiletSeatCompleteInstallation(0);
    setHighCommodeInstallationExistingLines(0);
    setBlockageClearingHighCommode(0);
    setBlockageClearingLowCommode(0);
    setBathroomDrainLineCleaning(0);
    setGeyserInstallation(0);
    setKitchenSinkSetupExistingLines(0);
    setSinkBlockageCleaning(0);
    setWashingMachinePointSetup(0);
    setIssueCheckup(false);
    setRemarks("");
    setUseSameServitor(false);
    setFormData({});
  };

  // PlusMinusInput Component
  const PlusMinusInput = ({ id, value, setValue, min = 0, max = Infinity }) => {
    const { t } = useTranslation();
    const inc = () => value < max && setValue(value + 1);
    const dec = () => value > min && setValue(value - 1);
    const display = `${value} ${t(
      value === 1 ? "plumber.form.unit" : "plumber.form.units"
    )}`;
    return (
      <div className="PlumberService-plusMinusInput">
        <button
          type="button"
          className="PlumberService-minusBtn"
          onClick={dec}
          disabled={value <= min}
        >
          −
        </button>
        <span className="PlumberService-valueDisplay">{display}</span>
        <button
          type="button"
          className="PlumberService-plusBtn"
          onClick={inc}
          disabled={value >= max}
        >
          +
        </button>
      </div>
    );
  };

  return (
    <>
      <div className="PlumberService-container">
        <SEO
          title="Plumber Service in Dhaka | HelpNao"
          description="Book trusted plumbers for faucet installation, pipe repair, water leakage, toilet & commode issues, geyser setup, and emergency plumbing. Verified professionals, fast service."
          path="/services/plumber"
          lang="en"
          jsonLd={{
            "@context": "https://schema.org",
            "@type": "Service",
            name: "Plumber Service",
            serviceType: "Plumbing",
            provider: {
              "@type": "Organization",
              name: "HelpNao",
              url: "https://helpnao.com",
            },
            areaServed: { "@type": "City", name: "Dhaka" },
            hasOfferCatalog: {
              "@type": "OfferCatalog",
              name: "Plumbing Services",
              itemListElement: [
                {
                  "@type": "Offer",
                  itemOffered: {
                    "@type": "Service",
                    name: "Faucet / Tap Installation & Repair",
                  },
                },
                {
                  "@type": "Offer",
                  itemOffered: {
                    "@type": "Service",
                    name: "Pipe Leakage & Pipe Repair",
                  },
                },
                {
                  "@type": "Offer",
                  itemOffered: {
                    "@type": "Service",
                    name: "Toilet / Commode Fixing",
                  },
                },
                {
                  "@type": "Offer",
                  itemOffered: {
                    "@type": "Service",
                    name: "Water Line & Drainage Issue",
                  },
                },
                {
                  "@type": "Offer",
                  itemOffered: { "@type": "Service", name: "Geyser Setup" },
                },
              ],
            },
          }}
        />

        <Navbar />
        <Loader show={loading} />

        {/* Service Card */}
        <div className="PlumberService-card">
          {/* Hero Section */}
          <div className="PlumberService-hero">
            <img src={heroImage} alt="Plumber Services Hero" />
          </div>

          <div className="PlumberService-header">
            <h1>
              {/* {rebookState ? 'Rebook Plumber Service' : 'Professional Plumber Services'} */}
              {t(
                rebookState
                  ? "plumber.header.rebook_title"
                  : "plumber.header.title"
              )}{" "}
              {/* CHANGED: Added translation */}
            </h1>
            {/* <div className="PlumberService-rating">★★★★★</div>
          <div className="PlumberService-reviews">45,000 Verified Reviews</div> */}

            <div className="PlumberService-rating">
              {renderStars(ratingData.avgRating)}
            </div>
            <div className="PlumberService-reviews">
              {ratingData.reviewCount.toLocaleString()}{" "}
              {t("plumber.reviewsLabel")}
            </div>
          </div>

          {/* <div className="PlumberService-categories">
            <div className="PlumberService-category">
              <h5>
                <span className="PlumberService-categoryIcon">🚽</span>

                {t("plumber.categories.toilet_services.title")}{" "}

              </h5>
              <p className="PlumberService-serviceDescription">

                {t("plumber.categories.toilet_services.description")}{" "}

              </p>
            </div>
            <div className="PlumberService-category">
              <h5>
                <span className="PlumberService-categoryIcon">🚰</span>
 
                {t("plumber.categories.faucet_sink_dishwasher.title")}{" "}

              </h5>
              <p className="PlumberService-serviceDescription">

                {t("plumber.categories.faucet_sink_dishwasher.description")}{" "}

              </p>
            </div>
            <div className="PlumberService-category">
              <h5>
                <span className="PlumberService-categoryIcon">💧</span>

                {t("plumber.categories.leak_shower_drain.title")}{" "}

              </h5>
              <p className="PlumberService-serviceDescription">

                {t("plumber.categories.leak_shower_drain.description")}{" "}

              </p>
            </div>
          </div> */}

          <form onSubmit={handleGetService} className="PlumberService-form">
            {/* Row 1: Bathroom Fixtures & Valves */}
            <h3 className="PlumberService-sectionTitle">
              <i className="fas fa-sink"></i>{" "}
              {t("plumber.form.sections.bathroom_fixtures.title")}
            </h3>
            <div className="PlumberService-serviceOptions">
              <div className="PlumberService-optionGroup">
                <label htmlFor="newBasin" className="tooltip-label">
                  {t("plumber.form.labels.new_basin_setup_existing_lines")}
                  <ServiceTooltip
                    title={
                      t(
                        "plumber.tooltips.new_basin_setup_existing_lines.title"
                      ) || "New Basin Setup (Existing Lines)"
                    }
                    description={t(
                      "plumber.tooltips.new_basin_setup_existing_lines.description",
                      {
                        price: unit("newBasinSetupExistingLines"),
                      }
                    )}
                  />
                </label>
                <PlusMinusInput
                  id="nbse"
                  value={newBasinSetupExistingLines}
                  setValue={setNewBasinSetupExistingLines}
                />
              </div>

              <div className="PlumberService-optionGroup">
                <label htmlFor="basinTap" className="tooltip-label">
                  {t("plumber.form.labels.basin_tap_setup")}
                  <ServiceTooltip
                    title={
                      t("plumber.tooltips.basin_tap_setup.title") ||
                      "Basin Tap Setup"
                    }
                    description={t(
                      "plumber.tooltips.basin_tap_setup.description",
                      {
                        price: unit("basinTapSetup"),
                      }
                    )}
                  />
                </label>
                <PlusMinusInput
                  id="bts"
                  value={basinTapSetup}
                  setValue={setBasinTapSetup}
                />
              </div>

              <div className="PlumberService-optionGroup">
                <label htmlFor="magicPipe" className="tooltip-label">
                  {t("plumber.form.labels.magic_pipe_setup")}
                  <ServiceTooltip
                    title={
                      t("plumber.tooltips.magic_pipe_setup.title") ||
                      "Magic Pipe Setup"
                    }
                    description={t(
                      "plumber.tooltips.magic_pipe_setup.description",
                      {
                        price: unit("magicPipeSetup"),
                      }
                    )}
                  />
                </label>
                <PlusMinusInput
                  id="mps"
                  value={magicPipeSetup}
                  setValue={setMagicPipeSetup}
                />
              </div>
            </div>
            <div className="PlumberService-serviceOptions">
              <div className="PlumberService-optionGroup">
                <label htmlFor="basinWaste" className="tooltip-label">
                  {t("plumber.form.labels.basin_waste_pop_up_setup")}
                  <ServiceTooltip
                    title={
                      t("plumber.tooltips.basin_waste_pop_up_setup.title") ||
                      "Basin Waste Pop Up Setup"
                    }
                    description={t(
                      "plumber.tooltips.basin_waste_pop_up_setup.description",
                      {
                        price: unit("basinWastePopUpSetup"),
                      }
                    )}
                  />
                </label>
                <PlusMinusInput
                  id="bwps"
                  value={basinWastePopUpSetup}
                  setValue={setBasinWastePopUpSetup}
                />
              </div>

              <div className="PlumberService-optionGroup">
                <label htmlFor="angleValve" className="tooltip-label">
                  {t("plumber.form.labels.angle_valve_setup")}
                  <ServiceTooltip
                    title={
                      t("plumber.tooltips.angle_valve_setup.title") ||
                      "Angle Valve Setup"
                    }
                    description={t(
                      "plumber.tooltips.angle_valve_setup.description",
                      {
                        price: unit("angleValveSetup"),
                      }
                    )}
                  />
                </label>
                <PlusMinusInput
                  id="avs"
                  value={angleValveSetup}
                  setValue={setAngleValveSetup}
                />
              </div>
            </div>

            {/* Row 2: Bathroom Accessories */}
            <h3 className="PlumberService-sectionTitle">
              <i className="fas fa-bath"></i>{" "}
              {t("plumber.form.sections.bathroom_accessories.title")}
            </h3>
            <div className="PlumberService-serviceOptions">
              <div className="PlumberService-optionGroup">
                <label htmlFor="bathroomTap" className="tooltip-label">
                  {t("plumber.form.labels.bathroom_tap_bib_cock_setup")}
                  <ServiceTooltip
                    title={
                      t("plumber.tooltips.bathroom_tap_bib_cock_setup.title") ||
                      "Bathroom Tap Bib Cock Setup"
                    }
                    description={t(
                      "plumber.tooltips.bathroom_tap_bib_cock_setup.description",
                      {
                        price: unit("bathroomTapBibCockSetup"),
                      }
                    )}
                  />
                </label>
                <PlusMinusInput
                  id="btbc"
                  value={bathroomTapBibCockSetup}
                  setValue={setBathroomTapBibCockSetup}
                />
              </div>
              <div className="PlumberService-optionGroup">
                <label htmlFor="tissueHolder" className="tooltip-label">
                  {t("plumber.form.labels.tissue_holder_setup")}
                  <ServiceTooltip
                    title={
                      t("plumber.tooltips.tissue_holder_setup.title") ||
                      "Tissue Holder Setup"
                    }
                    description={t(
                      "plumber.tooltips.tissue_holder_setup.description",
                      {
                        price: unit("tissueHolderSetup"),
                      }
                    )}
                  />
                </label>
                <PlusMinusInput
                  id="ths"
                  value={tissueHolderSetup}
                  setValue={setTissueHolderSetup}
                />
              </div>
              <div className="PlumberService-optionGroup">
                <label htmlFor="fillValve" className="tooltip-label">
                  {t("plumber.form.labels.fill_valve_replacement")}
                  <ServiceTooltip
                    title={
                      t("plumber.tooltips.fill_valve_replacement.title") ||
                      "Fill Valve Replacement"
                    }
                    description={t(
                      "plumber.tooltips.fill_valve_replacement.description",
                      {
                        price: unit("fillValveReplacement"),
                      }
                    )}
                  />
                </label>
                <PlusMinusInput
                  id="fvr"
                  value={fillValveReplacement}
                  setValue={setFillValveReplacement}
                />
              </div>
              <div className="PlumberService-optionGroup">
                <label htmlFor="handShower" className="tooltip-label">
                  {t("plumber.form.labels.hand_shower_setup")}
                  <ServiceTooltip
                    title={
                      t("plumber.tooltips.hand_shower_setup.title") ||
                      "Hand Shower Setup"
                    }
                    description={t(
                      "plumber.tooltips.hand_shower_setup.description",
                      {
                        price: unit("handShowerSetup"),
                      }
                    )}
                  />
                </label>
                <PlusMinusInput
                  id="hss"
                  value={handShowerSetup}
                  setValue={setHandShowerSetup}
                />
              </div>
            </div>
            <div className="PlumberService-serviceOptions">
              <div className="PlumberService-optionGroup">
                <label htmlFor="soapDish" className="tooltip-label">
                  {t("plumber.form.labels.soap_dish_setup")}
                  <ServiceTooltip
                    title={
                      t("plumber.tooltips.soap_dish_setup.title") ||
                      "Soap Dish Setup"
                    }
                    description={t(
                      "plumber.tooltips.soap_dish_setup.description",
                      {
                        price: unit("soapDishSetup"),
                      }
                    )}
                  />
                </label>
                <PlusMinusInput
                  id="sds"
                  value={soapDishSetup}
                  setValue={setSoapDishSetup}
                />
              </div>
              <div className="PlumberService-optionGroup">
                <label htmlFor="bathroomShelf" className="tooltip-label">
                  {t("plumber.form.labels.bathroom_shelf_setup")}
                  <ServiceTooltip
                    title={
                      t("plumber.tooltips.bathroom_shelf_setup.title") ||
                      "Bathroom Shelf Setup"
                    }
                    description={t(
                      "plumber.tooltips.bathroom_shelf_setup.description",
                      {
                        price: unit("bathroomShelfSetup"),
                      }
                    )}
                  />
                </label>
                <PlusMinusInput
                  id="bss"
                  value={bathroomShelfSetup}
                  setValue={setBathroomShelfSetup}
                />
              </div>
              <div className="PlumberService-optionGroup">
                <label htmlFor="mirror" className="tooltip-label">
                  {t("plumber.form.labels.mirror_setup")}
                  <ServiceTooltip
                    title={
                      t("plumber.tooltips.mirror_setup.title") || "Mirror Setup"
                    }
                    description={t(
                      "plumber.tooltips.mirror_setup.description",
                      {
                        price: unit("mirrorSetup"),
                      }
                    )}
                  />
                </label>
                <PlusMinusInput
                  id="ms"
                  value={mirrorSetup}
                  setValue={setMirrorSetup}
                />
              </div>
              <div className="PlumberService-optionGroup">
                <label htmlFor="towelHanger" className="tooltip-label">
                  {t("plumber.form.labels.towel_hanger_setup")}
                  <ServiceTooltip
                    title={
                      t("plumber.tooltips.towel_hanger_setup.title") ||
                      "Towel Hanger Setup"
                    }
                    description={t(
                      "plumber.tooltips.towel_hanger_setup.description",
                      {
                        price: unit("towelHangerSetup"),
                      }
                    )}
                  />
                </label>
                <PlusMinusInput
                  id="ths2"
                  value={towelHangerSetup}
                  setValue={setTowelHangerSetup}
                />
              </div>
            </div>
            <div className="PlumberService-serviceOptions">
              <div className="PlumberService-optionGroup">
                <label htmlFor="showerHead" className="tooltip-label">
                  {t("plumber.form.labels.shower_head_setup")}
                  <ServiceTooltip
                    title={
                      t("plumber.tooltips.shower_head_setup.title") ||
                      "Shower Head Setup"
                    }
                    description={t(
                      "plumber.tooltips.shower_head_setup.description",
                      {
                        price: unit("showerHeadSetup"),
                      }
                    )}
                  />
                </label>
                <PlusMinusInput
                  id="shs"
                  value={showerHeadSetup}
                  setValue={setShowerHeadSetup}
                />
              </div>
              <div className="PlumberService-optionGroup">
                <label htmlFor="concealedStopcock" className="tooltip-label">
                  {t("plumber.form.labels.concealed_stopcock_setup")}
                  <ServiceTooltip
                    title={
                      t("plumber.tooltips.concealed_stopcock_setup.title") ||
                      "Concealed Stopcock Setup"
                    }
                    description={t(
                      "plumber.tooltips.concealed_stopcock_setup.description",
                      {
                        price: unit("concealedStopcockSetup"),
                      }
                    )}
                  />
                </label>
                <PlusMinusInput
                  id="css"
                  value={concealedStopcockSetup}
                  setValue={setConcealedStopcockSetup}
                />
              </div>
              <div className="PlumberService-optionGroup">
                <label htmlFor="floorDrain" className="tooltip-label">
                  {t("plumber.form.labels.floor_drain_net_setup")}
                  <ServiceTooltip
                    title={
                      t("plumber.tooltips.floor_drain_net_setup.title") ||
                      "Floor Drain Net Setup"
                    }
                    description={t(
                      "plumber.tooltips.floor_drain_net_setup.description",
                      {
                        price: unit("floorDrainNetSetup"),
                      }
                    )}
                  />
                </label>
                <PlusMinusInput
                  id="fdns"
                  value={floorDrainNetSetup}
                  setValue={setFloorDrainNetSetup}
                />
              </div>
            </div>

            {/* Row 3: Toilet & Commode Services */}
            <h3 className="PlumberService-sectionTitle">
              <i className="fas fa-toilet"></i>{" "}
              {t("plumber.form.sections.toilet_commode.title")}
            </h3>
            <div className="PlumberService-serviceOptions">
              <div className="PlumberService-optionGroup">
                <label htmlFor="toiletSeatCover" className="tooltip-label">
                  {t("plumber.form.labels.toilet_seat_cover_replacement")}
                  <ServiceTooltip
                    title={
                      t(
                        "plumber.tooltips.toilet_seat_cover_replacement.title"
                      ) || "Toilet Seat Cover Replacement"
                    }
                    description={t(
                      "plumber.tooltips.toilet_seat_cover_replacement.description",
                      {
                        price: unit("toiletSeatCoverReplacement"),
                      }
                    )}
                  />
                </label>
                <PlusMinusInput
                  id="tscr"
                  value={toiletSeatCoverReplacement}
                  setValue={setToiletSeatCoverReplacement}
                />
              </div>
              <div className="PlumberService-optionGroup">
                <label htmlFor="toiletSeatComplete" className="tooltip-label">
                  {t("plumber.form.labels.toilet_seat_complete_installation")}
                  <ServiceTooltip
                    title={
                      t(
                        "plumber.tooltips.toilet_seat_complete_installation.title"
                      ) || "Toilet Seat Complete Installation"
                    }
                    description={t(
                      "plumber.tooltips.toilet_seat_complete_installation.description",
                      {
                        price: unit("toiletSeatCompleteInstallation"),
                      }
                    )}
                  />
                </label>
                <PlusMinusInput
                  id="tsci"
                  value={toiletSeatCompleteInstallation}
                  setValue={setToiletSeatCompleteInstallation}
                />
              </div>
              <div className="PlumberService-optionGroup">
                <label htmlFor="highCommode" className="tooltip-label">
                  {t(
                    "plumber.form.labels.high_commode_installation_existing_lines"
                  )}
                  <ServiceTooltip
                    title={
                      t(
                        "plumber.tooltips.high_commode_installation_existing_lines.title"
                      ) || "High Commode Installation (Existing Lines)"
                    }
                    description={t(
                      "plumber.tooltips.high_commode_installation_existing_lines.description",
                      {
                        price: unit("highCommodeInstallationExistingLines"),
                      }
                    )}
                  />
                </label>
                <PlusMinusInput
                  id="hcie"
                  value={highCommodeInstallationExistingLines}
                  setValue={setHighCommodeInstallationExistingLines}
                />
              </div>
            </div>
            <div className="PlumberService-serviceOptions">
              <div className="PlumberService-optionGroup">
                <label htmlFor="blockageHigh" className="tooltip-label">
                  {t("plumber.form.labels.blockage_clearing_high_commode")}
                  <ServiceTooltip
                    title={
                      t(
                        "plumber.tooltips.blockage_clearing_high_commode.title"
                      ) || "Blockage Clearing High Commode"
                    }
                    description={t(
                      "plumber.tooltips.blockage_clearing_high_commode.description",
                      {
                        price: unit("blockageClearingHighCommode"),
                      }
                    )}
                  />
                </label>
                <PlusMinusInput
                  id="bchc"
                  value={blockageClearingHighCommode}
                  setValue={setBlockageClearingHighCommode}
                />
              </div>
              <div className="PlumberService-optionGroup">
                <label htmlFor="blockageLow" className="tooltip-label">
                  {t("plumber.form.labels.blockage_clearing_low_commode")}
                  <ServiceTooltip
                    title={
                      t(
                        "plumber.tooltips.blockage_clearing_low_commode.title"
                      ) || "Blockage Clearing Low Commode"
                    }
                    description={t(
                      "plumber.tooltips.blockage_clearing_low_commode.description",
                      {
                        price: unit("blockageClearingLowCommode"),
                      }
                    )}
                  />
                </label>
                <PlusMinusInput
                  id="bclc"
                  value={blockageClearingLowCommode}
                  setValue={setBlockageClearingLowCommode}
                />
              </div>
              <div className="PlumberService-optionGroup">
                <label htmlFor="bathroomDrain" className="tooltip-label">
                  {t("plumber.form.labels.bathroom_drain_line_cleaning")}
                  <ServiceTooltip
                    title={
                      t(
                        "plumber.tooltips.bathroom_drain_line_cleaning.title"
                      ) || "Bathroom Drain Line Cleaning"
                    }
                    description={t(
                      "plumber.tooltips.bathroom_drain_line_cleaning.description",
                      {
                        price: unit("bathroomDrainLineCleaning"),
                      }
                    )}
                  />
                </label>
                <PlusMinusInput
                  id="bdlc"
                  value={bathroomDrainLineCleaning}
                  setValue={setBathroomDrainLineCleaning}
                />
              </div>
            </div>

            {/* Row 4: Geyser, Kitchen & Washing */}
            <h3 className="PlumberService-sectionTitle">
              <i className="fas fa-fire"></i>{" "}
              {t("plumber.form.sections.geyser_kitchen.title")}
            </h3>
            <div className="PlumberService-serviceOptions">
              <div className="PlumberService-optionGroup">
                <label htmlFor="geyserInstall" className="tooltip-label">
                  {t("plumber.form.labels.geyser_installation")}
                  <ServiceTooltip
                    title={
                      t("plumber.tooltips.geyser_installation.title") ||
                      "Geyser Installation"
                    }
                    description={t(
                      "plumber.tooltips.geyser_installation.description",
                      {
                        price: unit("geyserInstallation"),
                      }
                    )}
                  />
                </label>
                <PlusMinusInput
                  id="gi"
                  value={geyserInstallation}
                  setValue={setGeyserInstallation}
                />
              </div>
              <div className="PlumberService-optionGroup">
                <label htmlFor="kitchenSink" className="tooltip-label">
                  {t("plumber.form.labels.kitchen_sink_setup_existing_lines")}
                  <ServiceTooltip
                    title={
                      t(
                        "plumber.tooltips.kitchen_sink_setup_existing_lines.title"
                      ) || "Kitchen Sink Setup (Existing Lines)"
                    }
                    description={t(
                      "plumber.tooltips.kitchen_sink_setup_existing_lines.description",
                      {
                        price: unit("kitchenSinkSetupExistingLines"),
                      }
                    )}
                  />
                </label>
                <PlusMinusInput
                  id="ksse"
                  value={kitchenSinkSetupExistingLines}
                  setValue={setKitchenSinkSetupExistingLines}
                />
              </div>
            </div>
            <div className="PlumberService-serviceOptions">
              <div className="PlumberService-optionGroup">
                <label htmlFor="sinkBlockage" className="tooltip-label">
                  {t("plumber.form.labels.sink_blockage_cleaning")}
                  <ServiceTooltip
                    title={
                      t("plumber.tooltips.sink_blockage_cleaning.title") ||
                      "Sink Blockage Cleaning"
                    }
                    description={t(
                      "plumber.tooltips.sink_blockage_cleaning.description",
                      {
                        price: unit("sinkBlockageCleaning"),
                      }
                    )}
                  />
                </label>
                <PlusMinusInput
                  id="sbc"
                  value={sinkBlockageCleaning}
                  setValue={setSinkBlockageCleaning}
                />
              </div>
              <div className="PlumberService-optionGroup">
                <label htmlFor="washingMachine" className="tooltip-label">
                  {t("plumber.form.labels.washing_machine_point_setup")}
                  <ServiceTooltip
                    title={
                      t("plumber.tooltips.washing_machine_point_setup.title") ||
                      "Washing Machine Point Setup"
                    }
                    description={t(
                      "plumber.tooltips.washing_machine_point_setup.description",
                      {
                        price: unit("washingMachinePointSetup"),
                      }
                    )}
                  />
                </label>
                <PlusMinusInput
                  id="wmps"
                  value={washingMachinePointSetup}
                  setValue={setWashingMachinePointSetup}
                />
              </div>
            </div>

            <h3 className="PlumberService-sectionTitle">
              <i className="fas fa-stethoscope"></i>{" "}
              {t("plumber.form.sections.issue_checkup.title")}
            </h3>
            <div className="PlumberService-serviceOptions">
              <div className="PlumberService-optionGroup">
                <label htmlFor="issueCheckup" className="tooltip-label">
                  {t("plumber.form.labels.issue_checkup")}
                  <ServiceTooltip
                    title={
                      t("plumber.tooltips.issue_checkup.title") ||
                      "Issue Checkup"
                    }
                    description={t(
                      "plumber.tooltips.issue_checkup.description",
                      {
                        price: CHECKUP_FEE,
                      }
                    )}
                  />
                </label>
                <select
                  id="issueCheckup"
                  value={issueCheckup ? "yes" : "no"}
                  onChange={(e) => setIssueCheckup(e.target.value === "yes")}
                >
                  <option value="no">No</option>
                  <option value="yes">Yes</option>
                </select>
              </div>
            </div>

            {/* New added Rebook same servitor */}
            {rebookState && prevServitorName && (
              <div className="rebook-same-servitor">
                <label>
                  <input
                    type="checkbox"
                    checked={useSameServitor}
                    onChange={() => setUseSameServitor(!useSameServitor)}
                  />
                  {/* {t('electrician.form.rebook_same_servitor')} */}
                  {/* {` Do you want to book ${prevServitorName} again?`} */}
                  <span className="rebook-text">
                    {t("plumber.form.rebook_same_servitor_prefix")}
                    <span className="strong-name">{prevServitorName}</span>
                    {t("plumber.form.rebook_same_servitor_suffix")}
                  </span>
                </label>
              </div>
            )}

            {/* ---------- Price Breakdown Card (like AC) ---------- */}
            {breakdownRows.length > 0 && (
              <div className="PlumberService-breakdownCard" aria-live="polite">
                <div className="PlumberService-breakdownHeader">
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    aria-hidden="true"
                  >
                    <path d="M7 2h10a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2zm0 4v4h10V6H7zm0 6v6h10v-6H7zm2 1h2v2H9v-2zm0 3h2v2H9v-2zm4-3h2v2h-2v-2zm0 3h2v2h-2v-2z" />
                  </svg>
                  <span>{t("plumber.breakdown.title", "Price Breakdown")}</span>
                </div>
                <ul className="PlumberService-breakdownList">
                  {breakdownRows.map((row, idx) => (
                    <li key={idx} className="PlumberService-breakdownRow">
                      <span className="PlumberService-breakdownLabel">
                        {row.label}
                      </span>
                      <span className="PlumberService-breakdownRight">
                        {row.calc && (
                          <span className="PlumberService-breakdownCalc">
                            {row.calc}
                          </span>
                        )}
                        <span className="PlumberService-breakdownTotal">
                          {row.total}
                        </span>
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
            )}

            <div className="PlumberService-priceDisplay">
              <span>
                {/* Estimated Price: {calculatePrice()} tk */}
                {t("plumber.form.price_display", {
                  price: calculatePrice(),
                })}{" "}
                {/* CHANGED: Added translation */}
              </span>
            </div>

            {/* Pricing note banner */}
            <div
              className="PlumberService-priceNote"
              role="note"
              aria-live="polite"
            >
              <div className="PlumberService-priceNote-icon" aria-hidden="true">
                {/* small star icon (inline SVG) */}
                <svg
                  viewBox="0 0 24 24"
                  width="16"
                  height="16"
                  fill="currentColor"
                >
                  <path d="M12 17.27 18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
                </svg>
              </div>
              <div className="PlumberService-priceNote-content">
                <div className="PlumberService-priceNote-title">
                  {t("plumber.price_note.title")}
                </div>
                <p className="PlumberService-priceNote-text">
                  <strong>
                    {t("plumber.price_note.service_charges_only_label")}
                  </strong>{" "}
                  {t("plumber.price_note.body")}
                </p>
              </div>
            </div>

            <div className="PlumberService-bookingDetails">
              <div className="PlumberService-optionGroup">
                <label htmlFor="date">
                  {/* Preferred Date */}
                  {t("plumber.form.booking_details.labels.date")}{" "}
                  {/* CHANGED: Added translation */}
                </label>
                <div className="PlumberService-dateInputWrapper">
                  <DatePicker
                    selected={selectedDate}
                    onChange={(date) => setSelectedDate(date)}
                    dateFormat="dd-MMM-yyyy"
                    minDate={new Date()}
                    placeholderText={t(
                      "plumber.form.booking_details.date_placeholder"
                    )} // CHANGED: Added translation for placeholder
                    className="PlumberService-dateInput"
                  />
                  <FaCalendarAlt
                    className="PlumberService-dateIcon"
                    onClick={() =>
                      document
                        .querySelector(
                          ".react-datepicker__input-container input"
                        )
                        .click()
                    }
                  />
                </div>
              </div>
              <div className="PlumberService-optionGroup">
                <label htmlFor="time">
                  {/* Preferred Time */}
                  {t("plumber.form.booking_details.labels.time")}{" "}
                  {/* CHANGED: Added translation */}
                </label>
                <select id="time" name="time" required>
                  {generateTimeSlots(selectedDate).map((slot, idx) => (
                    <option key={idx} value={slot}>
                      {slot}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            {/* <h3 className="PlumberService-sectionTitle">
            <i className="fas fa-comment-alt"></i>
            {t("electrician.form.remarks_title")}{" "}
          </h3> */}
            <div className="PlumberService-serviceOptions">
              <div className="PlumberService-optionGroup PlumberService-fullWidth">
                <label htmlFor="remarks">
                  <i className="fas fa-comment-alt"></i>
                  {t("electrician.form.labels.remarks")}
                </label>
                <textarea
                  id="remarks"
                  value={remarks}
                  onChange={(e) => setRemarks(e.target.value)}
                  placeholder={t("electrician.form.placeholders.remarks")}
                  className="PlumberService-textarea"
                  rows="2"
                />
              </div>
            </div>

            <button
              type="submit"
              className="PlumberService-actionBtn"
              disabled={!hasAnySelection}
              aria-disabled={!hasAnySelection}
            >
              {/* {rebookState ? 'Confirm Rebooking' : 'Book Service Now'} */}
              {t(
                rebookState
                  ? "plumber.form.rebook_button"
                  : "plumber.form.submit_button"
              )}{" "}
              {/* CHANGED: Added translation */}
            </button>
          </form>

          <div className="PlumberService-infoBox">
            <h4>
              {/* About Our Plumber Services */}
              {t("plumber.info_box.title")} {/* CHANGED: Added translation */}
            </h4>
            <p>
              {/* Our certified plumbers deliver comprehensive installation, repair, and maintenance services... */}
              {t("plumber.info_box.description")}{" "}
              {/* CHANGED: Added translation */}
            </p>
          </div>

          <div className="PlumberService-additionalInfo">
            <div className="PlumberService-sectionCard">
              <h2 className="PlumberService-sectionTitle">
                {/* How to Place an Order */}
                {t("plumber.additional_info.how_to_place_order.title")}{" "}
                {/* CHANGED: Added translation */}
              </h2>
              <ol className="PlumberService-stepList">
                {t("plumber.additional_info.how_to_place_order.steps", {
                  returnObjects: true,
                }).map((step, index) => (
                  <li key={index}>{step}</li>
                ))}
              </ol>
            </div>

            <div className="PlumberService-row2col">
              <div className="PlumberService-sectionCard PlumberService-gradientBg2">
                <h2 className="PlumberService-sectionTitle">
                  {/* Why Choose HelpNao */}
                  {t("plumber.additional_info.why_choose_HelpNao.title")}{" "}
                  {/* CHANGED: Added translation */}
                </h2>
                <p className="PlumberService-sectionText">
                  {/* HelpNao connects you with highly skilled, background-checked plumbing professionals... */}
                  {t("plumber.additional_info.why_choose_HelpNao.description")}{" "}
                  {/* CHANGED: Added translation */}
                </p>
                <div className="PlumberService-featureGrid">
                  {t("plumber.additional_info.why_choose_HelpNao.features", {
                    returnObjects: true,
                  }).map((feature, index) => (
                    <div className="PlumberService-featureItem" key={index}>
                      <i
                        className={`fas fa-${
                          index === 0
                            ? "wrench"
                            : index === 1
                            ? "user-check"
                            : index === 2
                            ? "clock"
                            : "thumbs-up"
                        } PlumberService-featureIcon`}
                        aria-hidden="true"
                      ></i>
                      <p>{feature}</p>
                    </div>
                  ))}
                </div>
              </div>

              <div className="PlumberService-sectionCard PlumberService-gradientBg">
                <h2 className="PlumberService-sectionTitle">
                  {/* Key Features of Our Services */}
                  {t("plumber.additional_info.key_features.title")}{" "}
                  {/* CHANGED: Added translation */}
                </h2>
                <div className="PlumberService-featureGrid">
                  {t("plumber.additional_info.key_features.features", {
                    returnObjects: true,
                  }).map((feature, index) => (
                    <div className="PlumberService-featureItem" key={index}>
                      <i
                        className={`fas fa-${
                          index === 0
                            ? "check-circle"
                            : index === 1
                            ? "shield-alt"
                            : index === 2
                            ? "hand-holding-water"
                            : index === 3
                            ? "headset"
                            : "headset"
                        } PlumberService-featureIcon`}
                        aria-hidden="true"
                      ></i>
                      <p>{feature}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div className="PlumberService-sectionCard PlumberService-gradientBg3">
              <h2 className="PlumberService-sectionTitle">
                {/* Order Tracking & History */}
                {t("plumber.additional_info.order_tracking.title")}{" "}
                {/* CHANGED: Added translation */}
              </h2>
              <div className="PlumberService-orderTrackIcon">
                <i className="fas fa-file-alt" aria-hidden="true"></i>
              </div>
              <p className="PlumberService-sectionText PlumberService-centerText">
                {/* After placing an order, track your service status and review your order details... */}
                {t("plumber.additional_info.order_tracking.description")}{" "}
                {/* CHANGED: Added translation */}
              </p>
            </div>
          </div>
        </div>

        {showOrderForm && (
          <PlumberOrderForm
            onClose={() => setShowOrderForm(false)}
            onSubmit={handleOrderSubmit}
            formData={formData}
            user={user}
            previousServitorName={prevServitorName}
          />
        )}

        {showLoginPrompt && (
          <PromptLoginCard onClose={() => setShowLoginPrompt(false)} />
        )}
      </div>

      {/* Add Feedback Section */}
      <div className="PlumberService-feedback-section">
        <FeedbackPage serviceType="Plumber" />
      </div>

      <Footer />
    </>
  );
};

export default Plumber;